// exercises.js

const EXERCISE_DATABASE = {
  // ══════════════════════════════════════════════════════════════════════════
  // PECTORAUX
  // ══════════════════════════════════════════════════════════════════════════
  
  "Développé couché barre": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé couché barre", needs: ["barre", "banc"] },
      { name: "Développé couché haltères", needs: ["halteres", "banc"] },
      { name: "Pompes", needs: [] }
    ]
  },
  
  "Développé couché haltères": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé couché haltères", needs: ["halteres", "banc"] },
      { name: "Pompes", needs: [] }
    ]
  },
  
  "Développé incliné barre": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé incliné barre", needs: ["barre", "banc"] },
      { name: "Développé incliné haltères", needs: ["halteres", "banc"] },
      { name: "Pompes inclinées", needs: [] }
    ]
  },
  
  "Développé incliné haltères": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé incliné haltères", needs: ["halteres", "banc"] },
      { name: "Pompes inclinées", needs: [] }
    ]
  },
  
  "Développé décliné barre": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé décliné barre", needs: ["barre", "banc"] },
      { name: "Pompes déclinées", needs: [] }
    ]
  },
  
  "Butterfly": { // MACHINE
    muscle: "Pectoraux",
    alternatives: [{ name: null, needs: [] }]
  },
  
  
  "Écarté poulie haute": { // POULIE
    muscle: "Pectoraux",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Écarté poulie basse": { // POULIE
    muscle: "Pectoraux",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Écarté haltères": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Écarté haltères", needs: ["halteres", "banc"] },
      { name: "Pompes écartées", needs: [] }
    ]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // DOS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Tractions pronation": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions pronation", needs: ["barre_traction"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  
  "Tractions supination": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions supination", needs: ["barre_traction"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  
  "Tirage vertical": { // POULIE/MACHINE
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Tirage poulie haute prise large": { // POULIE
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Tirage poulie basse prise serrée": { // POULIE
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Tirage horizontal": { // POULIE/MACHINE
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Rowing barre": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing barre", needs: ["barre"] },
      { name: "Rowing haltères", needs: ["halteres"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  
  "Rowing haltères": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing haltères", needs: ["halteres"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  
  "Rowing haltère unilatéral": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing haltère unilatéral", needs: ["halteres"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  
  "Rowing bûcheron": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing bûcheron", needs: ["halteres"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  
  "Rowing machine": { // MACHINE
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Pull-over haltère": {
    muscle: "Dos",
    alternatives: [
      { name: "Pull-over haltère", needs: ["halteres", "banc"] },
      { name: "Superman", needs: [] }
    ]
  },
  
  "Pull-over poulie": { // POULIE
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // ÉPAULES
  // ══════════════════════════════════════════════════════════════════════════
  
  "Développé militaire barre": {
    muscle: "Épaules",
    alternatives: [
      { name: "Développé militaire barre", needs: ["barre"] },
      { name: "Développé militaire haltères", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] }
    ]
  },
  
  "Développé militaire haltères": {
    muscle: "Épaules",
    alternatives: [
      { name: "Développé militaire haltères", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] }
    ]
  },
  
  "Développé militaire machine": { // MACHINE
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Développé Arnold": {
    muscle: "Épaules",
    alternatives: [
      { name: "Développé Arnold", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] }
    ]
  },
  
  "Élévations latérales haltères": {
    muscle: "Épaules",
    alternatives: [
      { name: "Élévations latérales haltères", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] }
    ]
  },
  
  "Élévations latérales poulie": { // POULIE
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Élévations frontales haltères": {
    muscle: "Épaules",
    alternatives: [
      { name: "Élévations frontales haltères", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] }
    ]
  },
  
  "Élévations frontales poulie": { // POULIE
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Oiseau haltères": {
    muscle: "Épaules",
    alternatives: [
      { name: "Oiseau haltères", needs: ["halteres"] },
      { name: "Superman latéral", needs: [] }
    ]
  },
  
  "Face pull": { // POULIE
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Tirage menton barre": {
    muscle: "Épaules",
    alternatives: [
      { name: "Tirage menton barre", needs: ["barre"] },
      { name: "Tirage menton haltères", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] }
    ]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // BICEPS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Curl barre": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl barre", needs: ["barre"] },
      { name: "Curl haltères", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] }
    ]
  },
  
  "Curl barre EZ": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl barre", needs: ["barre"] },
      { name: "Curl haltères", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] }
    ]
  },
  
  "Curl haltères": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl haltères", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] }
    ]
  },
  
  "Curl haltères alternés": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl haltères alternés", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] }
    ]
  },
  
  "Curl marteau": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl marteau", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] }
    ]
  },
  
  "Curl concentré": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl concentré", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] }
    ]
  },
  
  "Curl poulie": { // POULIE
    muscle: "Biceps",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Curl pupitre": { // MACHINE
    muscle: "Biceps",
    alternatives: [{ name: null, needs: [] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TRICEPS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Dips": {
    muscle: "Triceps",
    alternatives: [
      { name: "Dips", needs: [] }
    ]
  },
  
  "Barre au front": {
    muscle: "Triceps",
    alternatives: [
      { name: "Barre au front", needs: ["barre"] },
      { name: "Extension nuque haltère", needs: ["halteres"] },
      { name: "Dips", needs: [] }
    ]
  },
  
  "Extension nuque haltère": {
    muscle: "Triceps",
    alternatives: [
      { name: "Extension nuque haltère", needs: ["halteres"] },
      { name: "Dips", needs: [] }
    ]
  },
  
  "Kickback haltères": {
    muscle: "Triceps",
    alternatives: [
      { name: "Kickback haltères", needs: ["halteres"] },
      { name: "Pompes diamant", needs: [] }
    ]
  },
  
  "Triceps poulie haute": { // POULIE
    muscle: "Triceps",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Triceps poulie haute corde": { // POULIE
    muscle: "Triceps",
    alternatives: [{ name: null, needs: [] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // QUADRICEPS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Squat barre": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat barre", needs: ["barre"] },
      { name: "Squat goblet", needs: ["halteres"] },
      { name: "Squat", needs: [] }
    ]
  },
  
  "Squat avant": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat avant", needs: ["barre"] },
      { name: "Squat goblet", needs: ["halteres"] },
      { name: "Squat", needs: [] }
    ]
  },
  
  "Squat goblet": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat goblet", needs: ["halteres"] },
      { name: "Squat", needs: [] }
    ]
  },
  
  "Fentes barre": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes barre", needs: ["barre"] },
      { name: "Fentes haltères", needs: ["halteres"] },
      { name: "Fentes", needs: [] }
    ]
  },
  
  "Fentes haltères": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes haltères", needs: ["halteres"] },
      { name: "Fentes", needs: [] }
    ]
  },
  
  "Fentes bulgares": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes bulgares haltères", needs: ["halteres"] },
      { name: "Fentes bulgares", needs: [] }
    ]
  },
  
  "Presse": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Presse à cuisses": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: null, needs: [] }]
  },
      
  "Squat machine": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: null, needs: [] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // ISCHIO-JAMBIERS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Soulevé de terre": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Soulevé de terre", needs: ["barre"] },
      { name: "Soulevé de terre haltères", needs: ["halteres"] },
      { name: "Nordic curl", needs: [] }
    ]
  },
  
  "Soulevé de terre roumain": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Soulevé de terre roumain", needs: ["barre"] },
      { name: "Soulevé de terre roumain haltères", needs: ["halteres"] },
      { name: "Nordic curl", needs: [] }
    ]
  },
  
  "Good morning": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Good morning", needs: ["barre"] },
      { name: "Nordic curl", needs: [] }
    ]
  },
  
  "Leg curl couché machine": { // MACHINE
    muscle: "Ischio-jambiers",
    alternatives: [{ name: "Leg curl couché machine", needs: ["salle"] }]
  },
  
  "Leg curl assis machine": { // MACHINE
    muscle: "Ischio-jambiers",
    alternatives: [{ name: "Leg curl assis machine", needs: ["salle"] }]
  },

  "Leg curl debout unilatéral": { // MACHINE
    muscle: "Ischio-jambiers",
    alternatives: [{ name: "Leg curl debout unilatéral", needs: ["salle"] }]
  },
  
  "Leg curl assis": { // MACHINE
    muscle: "Ischio-jambiers",
    alternatives: [{ name: "Leg curl assis", needs: ["salle"] }]
  },
  
  "Leg curl allongé": { // MACHINE
    muscle: "Ischio-jambiers",
    alternatives: [{ name: "Leg curl allongé", needs: ["salle"] }]
  },

  "Leg press 45°": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: "Leg press 45°", needs: ["salle"] }]
  },

  "Leg press horizontal": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: "Leg press horizontal", needs: ["salle"] }]
  },

  "Rowing machine Hammer": { // MACHINE
    muscle: "Dos",
    alternatives: [{ name: "Rowing machine Hammer", needs: ["salle"] }]
  },

  "Squat barre Smith machine": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: "Squat barre Smith machine", needs: ["salle"] }]
  },

  "Hack squat machine": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: "Hack squat machine", needs: ["salle"] }]
  },

  "Extension quadriceps machine": { // MACHINE
    muscle: "Quadriceps",
    alternatives: [{ name: "Extension quadriceps machine", needs: ["salle"] }]
  },

  "Hip thrust machine": { // MACHINE
    muscle: "Fessiers",
    alternatives: [{ name: "Hip thrust machine", needs: ["salle"] }]
  },

  "Abduction machine assise": { // MACHINE
    muscle: "Fessiers",
    alternatives: [{ name: "Abduction machine assise", needs: ["salle"] }]
  },

  "Mollets debout machine": { // MACHINE
    muscle: "Mollets",
    alternatives: [{ name: "Mollets debout machine", needs: ["salle"] }]
  },

  "Mollets assis machine": { // MACHINE
    muscle: "Mollets",
    alternatives: [{ name: "Mollets assis machine", needs: ["salle"] }]
  },

  "Mollets à la presse": { // MACHINE
    muscle: "Mollets",
    alternatives: [{ name: "Mollets à la presse", needs: ["salle"] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // FESSIERS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Hip thrust": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Hip thrust barre", needs: ["barre", "banc"] },
      { name: "Hip thrust haltère", needs: ["halteres", "banc"] },
      { name: "Hip thrust", needs: [] }
    ]
  },
  
  
  "Abduction machine": { // MACHINE
    muscle: "Fessiers",
    alternatives: [{ name: "Abduction machine", needs: ["salle"] }]
  },
  
  "Kick back poulie": { // POULIE
    muscle: "Fessiers",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Donkey kicks": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Donkey kicks", needs: [] }
    ]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // MOLLETS
  // ══════════════════════════════════════════════════════════════════════════
  
  "Mollets debout": {
    muscle: "Mollets",
    alternatives: [
      { name: "Mollets debout barre", needs: ["barre"] },
      { name: "Mollets debout haltère", needs: ["halteres"] },
      { name: "Mollets debout", needs: [] }
    ]
  },
  
  "Mollets machine": { // MACHINE
    muscle: "Mollets",
    alternatives: [{ name: "Mollets machine", needs: ["salle"] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // ABDOMINAUX
  // ══════════════════════════════════════════════════════════════════════════
  
  "Crunch": {
    muscle: "Abdominaux",
    alternatives: [{ name: "Crunch", needs: [] }]
  },
  
  "Crunch poulie": { // POULIE
    muscle: "Abdominaux",
    alternatives: [{ name: null, needs: [] }]
  },
  
  "Relevé de jambes": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Relevé de jambes barre", needs: ["barre_traction"] },
      { name: "Relevé de jambes", needs: [] }
    ]
  },
  
  "Planche": {
    muscle: "Abdominaux",
    alternatives: [{ name: "Planche", needs: [] }]
  },
  
  "Russian twist": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Russian twist haltère", needs: ["halteres"] },
      { name: "Russian twist", needs: [] }
    ]
  },
  
  "Ab wheel": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Planche", needs: [] }
    ]
  },
  
  "Touché talons": {
    muscle: "Abdominaux",
    alternatives: [{ name: "Touché talons", needs: [] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TRAPÈZES
  // ══════════════════════════════════════════════════════════════════════════
  
  "Shrug barre": {
    muscle: "Trapèzes",
    alternatives: [
      { name: "Shrug barre", needs: ["barre"] },
      { name: "Shrug haltères", needs: ["halteres"] },
      { name: "Superman", needs: [] }
    ]
  },
  
  "Shrug haltères": {
    muscle: "Trapèzes",
    alternatives: [
      { name: "Shrug haltères", needs: ["halteres"] },
      { name: "Superman", needs: [] }
    ]
  },

  "Shrug câble": {
    muscle: "Trapèzes",
    alternatives: [
      { name: "Shrug câble", needs: ["cable"] },
      { name: "Shrug barre", needs: ["barre"] }
    ]
  },
  
  "Farmer walk": {
    muscle: "Trapèzes",
    alternatives: [
      { name: "Farmer walk haltères", needs: ["halteres"] },
      { name: "Farmer walk", needs: [] }
    ]
  },

  "Curl barre droite": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl barre droite", needs: ["barre"] },
    ]
  },

  "Sauts sur place": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Sauts sur place", needs: [] },
    ]
  },

  "Roue abdominale": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Roue abdominale", needs: [] },
    ]
  },

  "Dips sur chaise": {
    muscle: "Triceps",
    alternatives: [
      { name: "Dips sur chaise", needs: [] },
    ]
  },

  "Fentes latérales": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes latérales", needs: [] },
    ]
  },

  "Hip thrust unilatéral": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Hip thrust unilatéral", needs: ["barre"] },
      { name: "Donkey kick quadrupédie", needs: [] },
      { name: "Pont fessier au sol", needs: [] },
      { name: "Donkey kicks", needs: [] },
      { name: "Pont fessier", needs: [] },
      { name: "Hip thrust au sol", needs: [] },
    ]
  },

  "Pompes larges": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes larges", needs: [] },
    ]
  },

  "Tractions pronation large": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions pronation large", needs: ["barre_traction"] },
    ]
  },

  "Extension haltère allongé": {
    muscle: "Triceps",
    alternatives: [
      { name: "Extension haltère allongé", needs: ["halteres"] },
      { name: "Développé couché prise serrée", needs: [] },
      { name: "Dips triceps barres parallèles", needs: [] },
      { name: "Pompes diamant", needs: [] },
      { name: "Dips sur chaise", needs: [] },
    ]
  },

  "Rowing debout upright row": {
    muscle: "Trapèzes",
    alternatives: [
      { name: "Rowing debout upright row", needs: [] },
    ]
  },

  "Extension nuque barre EZ": {
    muscle: "Triceps",
    alternatives: [
      { name: "Extension nuque barre EZ", needs: ["barre"] },
      { name: "Développé couché prise serrée", needs: [] },
      { name: "Dips triceps barres parallèles", needs: [] },
      { name: "Pompes diamant", needs: [] },
      { name: "Dips sur chaise", needs: [] },
    ]
  },

  "Squat bulgare split squat": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat bulgare split squat", needs: [] },
    ]
  },

  "Corde à sauter (simulée)": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Corde à sauter (simulée)", needs: [] },
    ]
  },

  "Clean and press": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Clean and press", needs: [] },
    ]
  },

  "Farmer carry": {
    muscle: "Avant-bras",
    alternatives: [
      { name: "Farmer carry", needs: ["halteres"] },
    ]
  },

  "Burpees sans saut": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Burpees sans saut", needs: [] },
    ]
  },

  "Rowing barre pronation": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing barre pronation", needs: ["barre"] },
    ]
  },

  "Planche superman": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Planche superman", needs: [] },
    ]
  },

  "Dead bug": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Dead bug", needs: [] },
    ]
  },

  "Scissors (ciseaux)": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Scissors (ciseaux)", needs: [] },
    ]
  },

  "Planche latérale": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Planche latérale", needs: [] },
    ]
  },

  "Pompes sur genoux": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes sur genoux", needs: [] },
    ]
  },

  "Planche frontale isométrique": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Planche frontale isométrique", needs: [] },
    ]
  },

  "Soulevé de terre sumo": {
    muscle: "Dos",
    alternatives: [
      { name: "Soulevé de terre sumo", needs: ["barre"] },
    ]
  },

  "Donkey kick quadrupédie": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Donkey kick quadrupédie", needs: [] },
    ]
  },

  "Battle rope": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Battle rope", needs: [] },
    ]
  },

  "Kickback debout": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Kickback debout", needs: [] },
    ]
  },

  "Curl haltères alterné": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl haltères alterné", needs: ["halteres"] },
    ]
  },

  "Montées de genoux": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Montées de genoux", needs: [] },
    ]
  },

  "Pompes classiques": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes classiques", needs: [] },
    ]
  },

  "Dips triceps barres parallèles": {
    muscle: "Triceps",
    alternatives: [
      { name: "Dips triceps barres parallèles", needs: [] },
    ]
  },

  "Squat pulse": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat pulse", needs: [] },
    ]
  },

  "Tractions supination serrée": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions supination serrée", needs: ["barre_traction"] },
    ]
  },

  "Hip thrust au sol": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Hip thrust au sol", needs: [] },
    ]
  },

  "Pompes claquées": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes claquées", needs: [] },
    ]
  },

  "Développé couché prise serrée": {
    muscle: "Triceps",
    alternatives: [
      { name: "Développé couché prise serrée", needs: ["barre", "banc"] },
      { name: "Pompes diamant", needs: [] },
    ]
  },

  "Curl pupitre Scott barre EZ": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl pupitre Scott barre EZ", needs: ["barre"] },
    ]
  },

  "Abdominaux portefeuille": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Abdominaux portefeuille", needs: [] },
    ]
  },

  "Fentes avant haltères": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes avant haltères", needs: ["halteres"] },
      { name: "Squat avant front squat", needs: [] },
      { name: "Squat bulgare split squat", needs: [] },
      { name: "Squat sumo", needs: [] },
      { name: "Fentes arrière reverse lunge", needs: [] },
      { name: "Fentes latérales", needs: [] },
    ]
  },

  "Gainage latéral": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Gainage latéral", needs: [] },
    ]
  },

  "Crunch classique": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Crunch classique", needs: [] },
    ]
  },

  "Bicycle crunch": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Bicycle crunch", needs: [] },
    ]
  },

  "Talons fesses": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Talons fesses", needs: [] },
    ]
  },

  "Box step-up (chaise)": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Box step-up (chaise)", needs: [] },
    ]
  },

  "Tractions lestées": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions lestées", needs: ["barre_traction"] },
    ]
  },

  "Fentes à la barre guidée": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes à la barre guidée", needs: ["barre"] },
      { name: "Squat avant front squat", needs: [] },
      { name: "Squat bulgare split squat", needs: [] },
      { name: "Squat sumo", needs: [] },
      { name: "Fentes arrière reverse lunge", needs: [] },
      { name: "Fentes latérales", needs: [] },
    ]
  },

  "Sprint sur place": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Sprint sur place", needs: [] },
    ]
  },

  "Curl poignets barre supination": {
    muscle: "Avant-bras",
    alternatives: [
      { name: "Curl poignets barre supination", needs: ["barre"] },
    ]
  },

  "Relevé de genoux suspendu": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Relevé de genoux suspendu", needs: [] },
    ]
  },

  "Pompes diamant": {
    muscle: "Triceps",
    alternatives: [
      { name: "Pompes diamant", needs: [] },
    ]
  },

  "Pompes Spiderman": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes Spiderman", needs: [] },
    ]
  },

  "Écarté haltères incliné": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Écarté haltères incliné", needs: ["halteres", "banc"] },
      { name: "Développé décliné haltères", needs: ["halteres"] },
      { name: "Écarté haltères plat", needs: ["halteres"] },
      { name: "Pompes", needs: [] },
      { name: "Pompes déclinées", needs: [] },
      { name: "Dips lestés", needs: [] },
    ]
  },

  "Jumping jacks": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Jumping jacks", needs: [] },
    ]
  },

  "Mountain climbers": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Mountain climbers", needs: [] },
    ]
  },

  "Soulevé de terre jambes raides": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Soulevé de terre jambes raides", needs: ["barre"] },
    ]
  },

  "Step-up sur chaise": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Step-up sur chaise", needs: [] },
    ]
  },

  "Chandelle": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Chandelle", needs: [] },
    ]
  },

  "Touche talons": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Touche talons", needs: [] },
    ]
  },

  "Rowing barre supination": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing barre supination", needs: ["barre"] },
    ]
  },

  "Fentes arrière reverse lunge": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes arrière reverse lunge", needs: [] },
    ]
  },

  "Squat isométrique mur": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat isométrique mur", needs: [] },
    ]
  },

  "Pompes déclinées": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes déclinées", needs: [] },
    ]
  },

  "Planche dynamique": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Planche dynamique", needs: [] },
    ]
  },

  "Barre au front Skull crusher": {
    muscle: "Triceps",
    alternatives: [
      { name: "Barre au front Skull crusher", needs: ["barre"] },
      { name: "Développé couché prise serrée", needs: [] },
      { name: "Dips triceps barres parallèles", needs: [] },
      { name: "Pompes diamant", needs: [] },
      { name: "Dips sur chaise", needs: [] },
    ]
  },

  "Dips lestés": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Dips lestés", needs: [] },
    ]
  },

  "Sit-ups": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Sit-ups", needs: [] },
    ]
  },

  "Squat avant front squat": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat avant front squat", needs: [] },
    ]
  },

  "Pompes": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pompes", needs: [] },
    ]
  },

  "Pont fessier": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Pont fessier", needs: [] },
    ]
  },

  "Pont fessier au sol": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Pont fessier au sol", needs: [] },
    ]
  },

  "Nordic curl GHR": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Nordic curl GHR", needs: ["halteres"] },
    ]
  },

  "Crunch obliques": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Crunch obliques", needs: [] },
    ]
  },

  "Mollets unilatéral escalier": {
    muscle: "Mollets",
    alternatives: [
      { name: "Mollets unilatéral escalier", needs: ["halteres"] },
    ]
  },

  "Oiseau haltères deltoïdes post": {
    muscle: "Épaules",
    alternatives: [
      { name: "Oiseau haltères deltoïdes post", needs: ["halteres"] },
      { name: "Développé Arnold", needs: ["halteres"] },
    ]
  },

  "Curl incliné haltères": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl incliné haltères", needs: ["halteres", "banc"] },
      { name: "Curl barre droite", needs: ["barre"] },
      { name: "Curl barre EZ", needs: ["barre"] },
      { name: "Curl haltères simultané", needs: ["halteres"] },
      { name: "Curl haltères alterné", needs: ["halteres"] },
      { name: "Curl marteau", needs: ["halteres"] },
    ]
  },

  "Curl concentration": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl concentration", needs: ["halteres"] },
    ]
  },

  "Corde à sauter": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Corde à sauter", needs: [] },
    ]
  },

  "Kettlebell swing": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Kettlebell swing", needs: [] },
    ]
  },

  // ── KETTLEBELL ─────────────────────────────────────────────────────────────
  "Goblet Squat kettlebell": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Goblet Squat kettlebell", needs: ["kettlebells"] },
      { name: "Squat gobelet", needs: ["halteres"] },
      { name: "Squats", needs: [] },
    ]
  },

  "Soulevé de terre kettlebell": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Soulevé de terre kettlebell", needs: ["kettlebells"] },
      { name: "Soulevé de terre roumain", needs: ["halteres"] },
      { name: "Good morning PDC", needs: [] },
    ]
  },

  "Fentes marchées kettlebell": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes marchées kettlebell", needs: ["kettlebells"] },
      { name: "Fentes avant haltères", needs: ["halteres"] },
      { name: "Fentes alternées", needs: [] },
    ]
  },

  "Développé épaules unilatéral kettlebell": {
    muscle: "Épaules",
    alternatives: [
      { name: "Développé épaules unilatéral kettlebell", needs: ["kettlebells"] },
      { name: "Développé militaire haltères", needs: ["halteres"] },
      { name: "Pompes pike", needs: [] },
    ]
  },

  "Rowing unilatéral kettlebell": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing unilatéral kettlebell", needs: ["kettlebells"] },
      { name: "Rowing haltère unilatéral", needs: ["halteres"] },
      { name: "Rowing inversé", needs: [] },
    ]
  },

  "Clean & Press kettlebell": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Clean & Press kettlebell", needs: ["kettlebells"] },
    ]
  },

  "Turkish Get-Up": {
    muscle: "Épaules",
    alternatives: [
      { name: "Turkish Get-Up", needs: ["kettlebells"] },
    ]
  },

  "Farmer Walk kettlebell": {
    muscle: "Avant-bras",
    alternatives: [
      { name: "Farmer Walk kettlebell", needs: ["kettlebells"] },
      { name: "Farmer carry", needs: ["halteres"] },
      { name: "Farmer walk", needs: [] },
    ]
  },

  "Russian Twist kettlebell": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Russian Twist kettlebell", needs: ["kettlebells"] },
      { name: "Russian twist", needs: [] },
    ]
  },

  // ── ÉLASTIQUES ────────────────────────────────────────────────────────────
  "Squat avec bande": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat avec bande", needs: ["elastiques"] },
      { name: "Squats", needs: [] },
    ]
  },

  "Hip Thrust avec bande": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Hip Thrust avec bande", needs: ["elastiques"] },
      { name: "Pont fessier au sol", needs: [] },
    ]
  },

  "Tirage horizontal élastique": {
    muscle: "Dos",
    alternatives: [
      { name: "Tirage horizontal élastique", needs: ["elastiques"] },
      { name: "Rowing inversé", needs: [] },
    ]
  },

  "Face Pull élastique": {
    muscle: "Épaules",
    alternatives: [
      { name: "Face Pull élastique", needs: ["elastiques"] },
      { name: "Oiseau haltères deltoïdes post", needs: ["halteres"] },
    ]
  },

  "Curl biceps élastique": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl biceps élastique", needs: ["elastiques"] },
      { name: "Curl haltères simultané", needs: ["halteres"] },
      { name: "Curl isométrique", needs: [] },
    ]
  },

  "Extension triceps élastique": {
    muscle: "Triceps",
    alternatives: [
      { name: "Extension triceps élastique", needs: ["elastiques"] },
      { name: "Kickback haltère", needs: ["halteres"] },
      { name: "Dips sur chaise", needs: [] },
    ]
  },

  "Développé poitrine élastique": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé poitrine élastique", needs: ["elastiques"] },
      { name: "Pompes", needs: [] },
    ]
  },

  "Élévations latérales élastique": {
    muscle: "Épaules",
    alternatives: [
      { name: "Élévations latérales élastique", needs: ["elastiques"] },
      { name: "Élévations latérales haltères", needs: ["halteres"] },
    ]
  },

  "Pallof Press": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Pallof Press", needs: ["elastiques"] },
      { name: "Planche frontale isométrique", needs: [] },
    ]
  },

  "Monster Walk": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Monster Walk", needs: ["elastiques"] },
      { name: "Donkey kick quadrupédie", needs: [] },
    ]
  },

  "Curl poignets barre pronation": {
    muscle: "Avant-bras",
    alternatives: [
      { name: "Curl poignets barre pronation", needs: ["barre"] },
    ]
  },

  "Squat jump": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat jump", needs: [] },
    ]
  },

  "Tractions neutres": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions neutres", needs: ["barre_traction"] },
    ]
  },

  "Pronation supination haltère": {
    muscle: "Avant-bras",
    alternatives: [
      { name: "Pronation supination haltère", needs: ["halteres"] },
    ]
  },

  "Squat barre low bar": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat barre low bar", needs: ["barre"] },
      { name: "Squat avant front squat", needs: [] },
      { name: "Squat bulgare split squat", needs: [] },
      { name: "Squat sumo", needs: [] },
      { name: "Fentes arrière reverse lunge", needs: [] },
      { name: "Fentes latérales", needs: [] },
    ]
  },

  "Squat gobelet": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat gobelet", needs: ["halteres"] },
      { name: "Squat avant front squat", needs: [] },
      { name: "Squat bulgare split squat", needs: [] },
      { name: "Squat sumo", needs: [] },
      { name: "Fentes arrière reverse lunge", needs: [] },
      { name: "Fentes latérales", needs: [] },
    ]
  },

  "Hip thrust barre": {
    muscle: "Fessiers",
    alternatives: [
      { name: "Hip thrust barre", needs: ["barre"] },
      { name: "Donkey kick quadrupédie", needs: [] },
      { name: "Pont fessier au sol", needs: [] },
      { name: "Donkey kicks", needs: [] },
      { name: "Pont fessier", needs: [] },
      { name: "Hip thrust au sol", needs: [] },
    ]
  },

  "Abdominaux coude genou croisés": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Abdominaux coude genou croisés", needs: [] },
    ]
  },

  "Écarté haltères plat": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Écarté haltères plat", needs: ["halteres"] },
      { name: "Pompes", needs: [] },
      { name: "Pompes déclinées", needs: [] },
      { name: "Dips lestés", needs: [] },
      { name: "Pompes classiques", needs: [] },
      { name: "Pompes larges", needs: [] },
    ]
  },

  "Fentes alternées": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes alternées", needs: [] },
    ]
  },

  "Kickback haltère": {
    muscle: "Triceps",
    alternatives: [
      { name: "Kickback haltère", needs: ["halteres"] },
      { name: "Développé couché prise serrée", needs: [] },
      { name: "Dips triceps barres parallèles", needs: [] },
      { name: "Pompes diamant", needs: [] },
      { name: "Dips sur chaise", needs: [] },
    ]
  },

  "Squats": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squats", needs: [] },
    ]
  },

  "Relevé de jambes suspendu": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Relevé de jambes suspendu", needs: [] },
    ]
  },

  "Box jump": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Box jump", needs: [] },
    ]
  },

  "Burpees": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Burpees", needs: [] },
    ]
  },

  "Fentes sautées": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes sautées", needs: [] },
    ]
  },

  "Curl haltères simultané": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl haltères simultané", needs: ["halteres"] },
    ]
  },

  "Mollets debout haltères": {
    muscle: "Mollets",
    alternatives: [
      { name: "Mollets debout haltères", needs: ["halteres"] },
    ]
  },

  "Squat sumo": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Squat sumo", needs: [] },
    ]
  },

  "Barre roulante wrist roller": {
    muscle: "Avant-bras",
    alternatives: [
      { name: "Barre roulante wrist roller", needs: ["barre"] },
    ]
  },

  "Développé décliné haltères": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Développé décliné haltères", needs: ["halteres"] },
      { name: "Pompes", needs: [] },
      { name: "Pompes déclinées", needs: [] },
      { name: "Dips lestés", needs: [] },
      { name: "Pompes classiques", needs: [] },
      { name: "Pompes larges", needs: [] },
    ]
  },

  "Thruster": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Thruster", needs: [] },
    ]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // EXERCICES POULIE/CÂBLE - TOUS SALLE_ONLY
  // ══════════════════════════════════════════════════════════════════════════
  
  "Écarté à la poulie haute": {
    muscle: "Pectoraux",
    alternatives: [{ name: null, needs: [] }]
  },

  "Écarté à la poulie basse": {
    muscle: "Pectoraux",
    alternatives: [{ name: null, needs: [] }]
  },

  "Rowing câble assis": {
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  "Tirage vertical prise large": {
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  "Tirage vertical prise serrée": {
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  "Tirage horizontal prise large": {
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  "Tirage horizontal prise serrée": {
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  "Pull-over poulie haute": {
    muscle: "Dos",
    alternatives: [{ name: null, needs: [] }]
  },

  "Élévations latérales câble": {
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },

  "Élévations frontales câble": {
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },

  "Oiseau câble deltoïdes post": {
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },

  "Face pull câble": {
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },

  "Tirage menton câble": {
    muscle: "Épaules",
    alternatives: [{ name: null, needs: [] }]
  },

  "Curl marteau câble corde": {
    muscle: "Biceps",
    alternatives: [{ name: null, needs: [] }]
  },

  "Curl câble poulie basse": {
    muscle: "Biceps",
    alternatives: [{ name: null, needs: [] }]
  },

  "Curl poulie haute": {
    muscle: "Biceps",
    alternatives: [{ name: null, needs: [] }]
  },

  "Triceps poulie haute barre": {
    muscle: "Triceps",
    alternatives: [{ name: null, needs: [] }]
  },


  "Triceps poulie basse overhead": {
    muscle: "Triceps",
    alternatives: [{ name: null, needs: [] }]
  },

  "Tirage corde triceps unilatéral": {
    muscle: "Triceps",
    alternatives: [{ name: null, needs: [] }]
  },

  "Curl ischios câble debout": {
    muscle: "Ischio-jambiers",
    alternatives: [{ name: null, needs: [] }]
  },

  "Abduction hanche câble": {
    muscle: "Fessiers",
    alternatives: [{ name: null, needs: [] }]
  },

  "Kickback câble fessiers": {
    muscle: "Fessiers",
    alternatives: [{ name: null, needs: [] }]
  },

  "Crunch câble agenouillé": {
    muscle: "Abdominaux",
    alternatives: [{ name: null, needs: [] }]
  },

  // ══════════════════════════════════════════════════════════════════════════
  // EXERCICES PDC ADDITIONNELS POUR MODE MAISON
  // ══════════════════════════════════════════════════════════════════════════
  


  "Rowing inversé": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing inversé", needs: [] }
    ]
  },

  "Superman": {
    muscle: "Dos",
    alternatives: [
      { name: "Superman", needs: [] }
    ]
  },

  "Curl isométrique": {
    muscle: "Biceps",
    alternatives: [
      { name: "Curl isométrique", needs: [] }
    ]
  },


  "Nordic curl": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Nordic curl", needs: [] }
    ]
  },

  "Glute bridge unilatéral": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Glute bridge unilatéral", needs: [] }
    ]
  },


  "Mollets sur marche": {
    muscle: "Mollets",
    alternatives: [
      { name: "Mollets sur marche", needs: [] }
    ]
  },


  // ── NOUVEAUX EXERCICES ────────────────────────────────────────────────────

  "Fentes avant": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes avant", needs: [] },
      { name: "Fentes avant haltères", needs: ["halteres"] },
    ]
  },

  "Crunch inversé": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Crunch inversé", needs: [] },
    ]
  },

  "Rowing buste penché haltères": {
    muscle: "Dos",
    alternatives: [
      { name: "Rowing buste penché haltères", needs: ["halteres"] },
      { name: "Rowing haltère unilatéral", needs: ["halteres"] },
      { name: "Rowing unilatéral kettlebell", needs: ["kettlebells"] },
    ]
  },

  "Fentes marchées haltères": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes marchées haltères", needs: ["halteres"] },
      { name: "Fentes marchées kettlebell", needs: ["kettlebells"] },
      { name: "Fentes avant", needs: [] },
    ]
  },

  "Tirage vertical élastique": {
    muscle: "Dos",
    alternatives: [
      { name: "Tirage vertical élastique", needs: ["elastiques"] },
      { name: "Tirage horizontal élastique", needs: ["elastiques"] },
      { name: "Tractions australiennes", needs: ["barre_traction"] },
    ]
  },

  "Fentes élastique": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Fentes élastique", needs: ["elastiques"] },
      { name: "Fentes avant", needs: [] },
      { name: "Fentes marchées haltères", needs: ["halteres"] },
    ]
  },

  "Snatch kettlebell": {
    muscle: "Cardio / Full body",
    alternatives: [
      { name: "Snatch kettlebell", needs: ["kettlebells"] },
      { name: "Kettlebell swing", needs: ["kettlebells"] },
    ]
  },

  "Dips sur banc": {
    muscle: "Triceps",
    alternatives: [
      { name: "Dips sur banc", needs: ["banc"] },
      { name: "Dips sur chaise", needs: [] },
      { name: "Pompes diamant", needs: [] },
    ]
  },

  "Tractions australiennes": {
    muscle: "Dos",
    alternatives: [
      { name: "Tractions australiennes", needs: ["barre_traction"] },
      { name: "Rowing haltère unilatéral", needs: ["halteres"] },
      { name: "Tirage horizontal élastique", needs: ["elastiques"] },
    ]
  },

  "Toes to bar": {
    muscle: "Abdominaux",
    alternatives: [
      { name: "Toes to bar", needs: ["barre_traction"] },
      { name: "Relevé de jambes", needs: [] },
      { name: "Crunch inversé", needs: [] },
    ]
  },

  // ── MACHINE / APPAREILS ──────────────────────────────────────────────────
  "Leg press": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Leg press", needs: ["presse"] },
      { name: "Squat barre", needs: ["barre"] },
      { name: "Squats", needs: [] }
    ]
  },
  "Leg extension": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Leg extension", needs: ["leg_extension"] },
      { name: "Squat isométrique mur", needs: [] },
      { name: "Fentes avant", needs: [] }
    ]
  },
  "Leg curl": {
    muscle: "Ischio-jambiers",
    alternatives: [
      { name: "Leg curl", needs: ["leg_curl"] },
      { name: "Nordic curl", needs: [] },
      { name: "Soulevé de terre roumain", needs: ["barre"] }
    ]
  },
  "Lat pulldown": {
    muscle: "Dos",
    alternatives: [
      { name: "Lat pulldown", needs: ["lat_pulldown"] },
      { name: "Tractions pronation large", needs: ["barre_traction"] },
      { name: "Tirage vertical élastique", needs: ["elastiques"] }
    ]
  },
  "Chest supported row": {
    muscle: "Dos",
    alternatives: [
      { name: "Chest supported row", needs: ["chest_supported_row"] },
      { name: "Rowing haltères", needs: ["halteres"] },
      { name: "Rowing inversé", needs: [] }
    ]
  },
  "Cable fly": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Cable fly", needs: ["cables"] },
      { name: "Pec fly élastique", needs: ["elastiques"] },
      { name: "Écarté haltères", needs: ["halteres"] }
    ]
  },
  "Hack squat": {
    muscle: "Quadriceps",
    alternatives: [
      { name: "Hack squat", needs: ["hack_squat"] },
      { name: "Leg press", needs: ["presse"] },
      { name: "Squat barre", needs: ["barre"] }
    ]
  },
  "Pec deck": {
    muscle: "Pectoraux",
    alternatives: [
      { name: "Pec deck", needs: ["pec_deck"] },
      { name: "Pec fly élastique", needs: ["elastiques"] },
      { name: "Écarté haltères", needs: ["halteres"] }
    ]
  },
  "Cable curl": {
    muscle: "Biceps",
    alternatives: [
      { name: "Cable curl", needs: ["cables"] },
      { name: "Curl haltères", needs: ["halteres"] },
      { name: "Curl biceps élastique", needs: ["elastiques"] }
    ]
  },
  "Triceps pushdown câble": {
    muscle: "Triceps",
    alternatives: [
      { name: "Triceps pushdown câble", needs: ["cables"] },
      { name: "Extension triceps élastique", needs: ["elastiques"] },
      { name: "Kickback haltères", needs: ["halteres"] }
    ]
  },
};

const EX = [
  {id:1,  name:"Développé couché barre",          muscle:"Pectoraux",    detail:"Pectoraux majeurs, deltoïdes antérieurs, triceps"},
  {id:2,  name:"Développé couché haltères",        muscle:"Pectoraux",    detail:"Pectoraux majeurs, stabilisateurs épaule"},
  {id:3,  name:"Développé incliné barre",          muscle:"Pectoraux",    detail:"Faisceau claviculaire, deltoïdes antérieurs"},
  {id:4,  name:"Développé incliné haltères",       muscle:"Pectoraux",    detail:"Haut des pectoraux, deltoïdes antérieurs"},
  {id:5,  name:"Développé décliné barre",          muscle:"Pectoraux",    detail:"Faisceau sternal, bas des pectoraux"},
  {id:6,  name:"Développé décliné haltères",       muscle:"Pectoraux",    detail:"Bas des pectoraux, grand dentelé"},
  {id:7,  name:"Écarté haltères plat",             muscle:"Pectoraux",    detail:"Pectoraux étirement, grand dentelé"},
  {id:8,  name:"Écarté haltères incliné",          muscle:"Pectoraux",    detail:"Haut des pectoraux, coracobrachiaux"},
  {id:9,  name:"Pec deck (papillon machine)",      muscle:"Pectoraux",    detail:"Pectoraux majeurs, adducteurs humérus"},
  {id:10, name:"Écarté à la poulie haute",         muscle:"Pectoraux",    detail:"Faisceau sternal, bas des pectoraux"},
  {id:201,name:"Écarté à la poulie basse",         muscle:"Pectoraux",    detail:"Haut des pectoraux, deltoïdes antérieurs"},
  {id:11, name:"Pompes",                           muscle:"Pectoraux",    detail:"Pectoraux, triceps, deltoïdes antérieurs"},
  {id:12, name:"Pompes déclinées",                 muscle:"Pectoraux",    detail:"Haut des pectoraux, deltoïdes antérieurs"},
  {id:13, name:"Dips lestés",                      muscle:"Pectoraux",    detail:"Bas des pectoraux, triceps, deltoïdes"},
  {id:14, name:"Pull-over haltère",                muscle:"Pectoraux",    detail:"Grand pectoral, grand dorsal, dentelé"},
  {id:15, name:"Tractions pronation large",        muscle:"Dos",          detail:"Grand dorsal, rhomboïdes, biceps"},
  {id:16, name:"Tractions supination serrée",      muscle:"Dos",          detail:"Grand dorsal, biceps brachial"},
  {id:17, name:"Tractions neutres",                muscle:"Dos",          detail:"Grand dorsal, biceps, brachioradial"},
  {id:18, name:"Tractions lestées",                muscle:"Dos",          detail:"Grand dorsal, rhomboïdes, trapèzes"},
  {id:19, name:"Rowing barre pronation",           muscle:"Dos",          detail:"Rhomboïdes, trapèzes moyens, grand dorsal"},
  {id:20, name:"Rowing barre supination",          muscle:"Dos",          detail:"Grand dorsal, biceps, rhomboïdes"},
  {id:21, name:"Rowing haltère unilatéral",        muscle:"Dos",          detail:"Grand dorsal, rhomboïdes, trapèzes inférieurs"},
  {id:22, name:"Rowing câble assis",               muscle:"Dos",          detail:"Rhomboïdes, trapèzes, grand dorsal"},
  {id:23, name:"Rowing machine Hammer",            muscle:"Dos",          detail:"Grand dorsal, rhomboïdes, deltoïdes postérieurs"},
  {id:24, name:"Tirage vertical prise large",      muscle:"Dos",          detail:"Grand dorsal, teres major, biceps"},
  {id:25, name:"Tirage vertical prise serrée",     muscle:"Dos",          detail:"Grand dorsal, biceps, rhomboïdes"},
  {id:26, name:"Tirage horizontal prise large",    muscle:"Dos",          detail:"Rhomboïdes, trapèzes, deltoïdes post."},
  {id:202,name:"Tirage horizontal prise serrée",   muscle:"Dos",          detail:"Grand dorsal, rhomboïdes, biceps"},
  {id:27, name:"Soulevé de terre",                 muscle:"Dos",          detail:"Érecteurs rachis, grand dorsal, quadriceps, fessiers"},
  {id:28, name:"Soulevé de terre roumain",         muscle:"Dos",          detail:"Ischio-jambiers, grand fessier, érecteurs rachis"},
  {id:29, name:"Soulevé de terre sumo",            muscle:"Dos",          detail:"Quadriceps, fessiers, érecteurs rachis, adducteurs"},
  {id:30, name:"Good morning",                     muscle:"Dos",          detail:"Érecteurs rachis, ischio-jambiers, grand fessier"},
  {id:31, name:"Pull-over poulie haute",           muscle:"Dos",          detail:"Grand dorsal, grand rond, long triceps"},
  {id:32, name:"Développé militaire barre",        muscle:"Épaules",      detail:"Deltoïdes antérieurs et médians, trapèzes"},
  {id:33, name:"Développé militaire haltères",     muscle:"Épaules",      detail:"Deltoïdes antérieurs, médians, triceps"},
  {id:34, name:"Développé Arnold",                 muscle:"Épaules",      detail:"Tous faisceaux deltoïdes, trapèzes"},
  {id:35, name:"Élévations latérales haltères",    muscle:"Épaules",      detail:"Deltoïdes médians (faisceau acromial)"},
  {id:36, name:"Élévations latérales câble",       muscle:"Épaules",      detail:"Deltoïdes médians, sus-épineux"},
  {id:37, name:"Élévations frontales haltères",    muscle:"Épaules",      detail:"Deltoïdes antérieurs, grand pectoral"},
  {id:38, name:"Élévations frontales câble",       muscle:"Épaules",      detail:"Deltoïdes antérieurs, biceps court"},
  {id:39, name:"Oiseau haltères deltoïdes post",   muscle:"Épaules",      detail:"Deltoïdes postérieurs, rhomboïdes, infra-épineux"},
  {id:40, name:"Oiseau câble deltoïdes post",      muscle:"Épaules",      detail:"Deltoïdes postérieurs, teres minor"},
  {id:41, name:"Face pull câble",                  muscle:"Épaules",      detail:"Deltoïdes postérieurs, rotateurs externes"},
  {id:42, name:"Tirage menton barre",              muscle:"Épaules",      detail:"Deltoïdes médians, trapèzes, biceps"},
  {id:43, name:"Tirage menton câble",              muscle:"Épaules",      detail:"Deltoïdes, trapèzes supérieurs"},
  {id:44, name:"Curl barre droite",                muscle:"Biceps",       detail:"Biceps brachial, brachial antérieur"},
  {id:45, name:"Curl barre EZ",                    muscle:"Biceps",       detail:"Biceps brachial, brachioradial"},
  {id:46, name:"Curl haltères simultané",          muscle:"Biceps",       detail:"Biceps, brachial, brachioradial"},
  {id:47, name:"Curl haltères alterné",            muscle:"Biceps",       detail:"Biceps brachial, supinateur"},
  {id:48, name:"Curl marteau",                     muscle:"Biceps",       detail:"Brachioradial, brachial, biceps court"},
  {id:49, name:"Curl marteau câble corde",         muscle:"Biceps",       detail:"Brachioradial, brachial antérieur"},
  {id:50, name:"Curl concentration",               muscle:"Biceps",       detail:"Longue portion biceps, isolation maximale"},
  {id:51, name:"Curl pupitre Scott barre EZ",      muscle:"Biceps",       detail:"Courte portion biceps, brachial"},
  {id:52, name:"Curl incliné haltères",            muscle:"Biceps",       detail:"Longue portion biceps, étirement complet"},
  {id:53, name:"Curl câble poulie basse",          muscle:"Biceps",       detail:"Biceps brachial, tension constante"},
  {id:203,name:"Curl poulie haute",                muscle:"Biceps",       detail:"Biceps, tension en raccourcissement"},
  {id:54, name:"Développé couché prise serrée",    muscle:"Triceps",      detail:"Triceps (longue portion), pectoraux, deltoïdes"},
  {id:55, name:"Barre au front Skull crusher",     muscle:"Triceps",      detail:"Triceps (tous chefs), isolation"},
  {id:56, name:"Extension nuque haltère",          muscle:"Triceps",      detail:"Longue portion triceps, étirement maximal"},
  {id:57, name:"Extension nuque barre EZ",         muscle:"Triceps",      detail:"Longue portion triceps"},
  {id:58, name:"Triceps poulie haute barre",       muscle:"Triceps",      detail:"Triceps (chef latéral et médial)"},
  {id:59, name:"Triceps poulie haute corde",       muscle:"Triceps",      detail:"Triceps, expansion latérale"},
  {id:60, name:"Triceps poulie basse overhead",    muscle:"Triceps",      detail:"Longue portion triceps, étirement"},
  {id:61, name:"Dips triceps barres parallèles",   muscle:"Triceps",      detail:"Triceps, pectoraux, deltoïdes"},
  {id:62, name:"Kickback haltère",                 muscle:"Triceps",      detail:"Chef latéral triceps, isolation"},
  {id:63, name:"Extension haltère allongé",        muscle:"Triceps",      detail:"Tous chefs triceps"},
  {id:64, name:"Pompes diamant",                   muscle:"Triceps",      detail:"Triceps, pectoraux médians"},
  {id:204,name:"Tirage corde triceps unilatéral",  muscle:"Triceps",      detail:"Triceps (chef latéral), isolation"},
  {id:65, name:"Squat barre low bar",              muscle:"Quadriceps",   detail:"Quadriceps, fessiers, ischio-jambiers"},
  {id:205,name:"Squat barre Smith machine",        muscle:"Quadriceps",   detail:"Quadriceps, fessiers, guidé"},
  {id:66, name:"Squat avant front squat",          muscle:"Quadriceps",   detail:"Quadriceps, érecteurs rachis, fessiers"},
  {id:67, name:"Squat gobelet",                    muscle:"Quadriceps",   detail:"Quadriceps, core, fessiers"},
  {id:68, name:"Squat bulgare split squat",        muscle:"Quadriceps",   detail:"Quadriceps, grand fessier, ischio-jambiers"},
  {id:69, name:"Squat sumo",                       muscle:"Quadriceps",   detail:"Quadriceps, adducteurs, fessiers"},
  {id:70, name:"Leg press 45°",                    muscle:"Quadriceps",   detail:"Quadriceps, fessiers, ischio-jambiers"},
  {id:71, name:"Leg press horizontal",             muscle:"Quadriceps",   detail:"Quadriceps, fessiers"},
  {id:72, name:"Hack squat machine",               muscle:"Quadriceps",   detail:"Vaste médial, quadriceps, fessiers"},
  {id:73, name:"Extension quadriceps machine",     muscle:"Quadriceps",   detail:"Quadriceps, isolation complète"},
  {id:74, name:"Fentes avant haltères",            muscle:"Quadriceps",   detail:"Quadriceps, grand fessier, ischio-jambiers"},
  {id:75, name:"Fentes arrière reverse lunge",     muscle:"Quadriceps",   detail:"Quadriceps, grand fessier"},
  {id:76, name:"Fentes latérales",                 muscle:"Quadriceps",   detail:"Adducteurs, quadriceps, fessiers"},
  {id:206,name:"Fentes à la barre guidée",         muscle:"Quadriceps",   detail:"Quadriceps, fessiers, guidé"},
  {id:77, name:"Leg curl couché machine",          muscle:"Ischio-jambiers", detail:"Biceps fémoral, semi-tendineux, semi-membraneux"},
  {id:78, name:"Leg curl assis machine",           muscle:"Ischio-jambiers", detail:"Ischio-jambiers, position courte"},
  {id:79, name:"Leg curl debout unilatéral",       muscle:"Ischio-jambiers", detail:"Ischio-jambiers, isolation unilatérale"},
  {id:80, name:"Nordic curl GHR",                  muscle:"Ischio-jambiers", detail:"Ischio-jambiers excentrique"},
  {id:81, name:"Soulevé de terre jambes raides",   muscle:"Ischio-jambiers", detail:"Ischio-jambiers, grand fessier, érecteurs"},
  {id:82, name:"Curl ischios câble debout",        muscle:"Ischio-jambiers", detail:"Biceps fémoral, semi-tendineux"},
  {id:83, name:"Glute ham raise",                  muscle:"Ischio-jambiers", detail:"Ischio-jambiers, grand fessier, érecteurs"},
  {id:84, name:"Hip thrust barre",                 muscle:"Fessiers",     detail:"Grand fessier, ischio-jambiers, core"},
  {id:85, name:"Hip thrust machine",               muscle:"Fessiers",     detail:"Grand fessier, moyen fessier"},
  {id:86, name:"Hip thrust unilatéral",            muscle:"Fessiers",     detail:"Grand fessier (isolation unilatérale)"},
  {id:87, name:"Abduction hanche câble",           muscle:"Fessiers",     detail:"Moyen et petit fessier, tenseur fascia lata"},
  {id:88, name:"Abduction machine assise",         muscle:"Fessiers",     detail:"Moyen fessier, petit fessier"},
  {id:89, name:"Kickback câble fessiers",          muscle:"Fessiers",     detail:"Grand fessier, ischio-jambiers"},
  {id:90, name:"Donkey kick quadrupédie",          muscle:"Fessiers",     detail:"Grand fessier, moyen fessier"},
  {id:91, name:"Pont fessier au sol",              muscle:"Fessiers",     detail:"Grand fessier, ischio-jambiers, core"},
  {id:92, name:"Mollets debout machine",           muscle:"Mollets",      detail:"Gastrocnémien (jumeaux), soléaire"},
  {id:93, name:"Mollets assis machine",            muscle:"Mollets",      detail:"Soléaire (profond), gastrocnémien"},
  {id:94, name:"Mollets à la presse",              muscle:"Mollets",      detail:"Gastrocnémien, soléaire"},
  {id:95, name:"Mollets debout haltères",          muscle:"Mollets",      detail:"Gastrocnémien, amplitude complète"},
  {id:96, name:"Mollets unilatéral escalier",      muscle:"Mollets",      detail:"Gastrocnémien, soléaire, étirement profond"},
  {id:97, name:"Crunch classique",                 muscle:"Abdominaux",   detail:"Droit abdominal (partie haute)"},
  {id:98, name:"Crunch câble agenouillé",          muscle:"Abdominaux",   detail:"Droit abdominal, tension constante"},
  {id:99, name:"Relevé de jambes suspendu",        muscle:"Abdominaux",   detail:"Droit abdominal bas, psoas, hip flexors"},
  {id:100,name:"Relevé de genoux suspendu",        muscle:"Abdominaux",   detail:"Droit abdominal, fléchisseurs hanche"},
  {id:101,name:"Planche frontale isométrique",     muscle:"Abdominaux",   detail:"Transverse, obliques, érecteurs rachis"},
  {id:102,name:"Gainage latéral",                  muscle:"Abdominaux",   detail:"Obliques, transverse, carré des lombes"},
  {id:103,name:"Russian twist",                    muscle:"Abdominaux",   detail:"Obliques, droit abdominal, rotation"},
  {id:104,name:"Roue abdominale",                  muscle:"Abdominaux",   detail:"Droit abdominal, obliques, grands dorsaux"},
  {id:105,name:"Dead bug",                         muscle:"Abdominaux",   detail:"Transverse, droit abdominal, stabilisateurs"},
  {id:106,name:"Bicycle crunch",                   muscle:"Abdominaux",   detail:"Obliques, droit abdominal, rotation"},
  {id:107,name:"Crunch obliques",                  muscle:"Abdominaux",   detail:"Obliques internes et externes"},
  {id:108,name:"Shrug barre",                      muscle:"Trapèzes",     detail:"Trapèzes supérieurs, élévateurs scapulaires"},
  {id:109,name:"Shrug haltères",                   muscle:"Trapèzes",     detail:"Trapèzes supérieurs, isolation"},
  {id:110,name:"Shrug câble",                      muscle:"Trapèzes",     detail:"Trapèzes supérieurs, tension constante"},
  {id:111,name:"Rowing debout upright row",        muscle:"Trapèzes",     detail:"Trapèzes, deltoïdes médians"},
  {id:112,name:"Curl poignets barre pronation",    muscle:"Avant-bras",   detail:"Extenseurs poignet, brachio-radial"},
  {id:113,name:"Curl poignets barre supination",   muscle:"Avant-bras",   detail:"Fléchisseurs poignet, avant-bras"},
  {id:114,name:"Farmer carry",                     muscle:"Avant-bras",   detail:"Fléchisseurs doigts, avant-bras, core"},
  {id:115,name:"Pronation supination haltère",     muscle:"Avant-bras",   detail:"Supinateur, rond pronateur, brachio-radial"},
  {id:116,name:"Barre roulante wrist roller",      muscle:"Avant-bras",   detail:"Fléchisseurs et extenseurs du poignet"},
  {id:117,name:"Corde à sauter",                   muscle:"Cardio / Full body", detail:"Cardio, mollets, coordination"},
  {id:118,name:"Burpees",                          muscle:"Cardio / Full body", detail:"Full body, cardio, coordination"},
  {id:119,name:"Mountain climbers",                muscle:"Cardio / Full body", detail:"Core, épaules, cardio"},
  {id:120,name:"Box jump",                         muscle:"Cardio / Full body", detail:"Quadriceps, fessiers, explosivité"},
  {id:121,name:"Kettlebell swing",                 muscle:"Cardio / Full body", detail:"Fessiers, ischio-jambiers, core, cardio"},
  {id:122,name:"Clean and press",                  muscle:"Cardio / Full body", detail:"Full body, puissance, coordination"},
  {id:123,name:"Thruster",                         muscle:"Cardio / Full body", detail:"Quadriceps, épaules, core"},
  {id:124,name:"Battle rope",                      muscle:"Cardio / Full body", detail:"Épaules, core, cardio intense"},
  // Kettlebell
  {id:125,name:"Goblet Squat kettlebell",          muscle:"Quadriceps",         detail:"Quadriceps, fessiers, adducteurs, gainage"},
  {id:126,name:"Soulevé de terre kettlebell",      muscle:"Ischio-jambiers",    detail:"Ischios-jambiers, fessiers, lombaires"},
  {id:127,name:"Fentes marchées kettlebell",       muscle:"Quadriceps",         detail:"Quadriceps, fessiers, ischios, mollets"},
  {id:128,name:"Développé épaules unilatéral kettlebell", muscle:"Épaules",     detail:"Deltoïdes, triceps, gainage"},
  {id:129,name:"Rowing unilatéral kettlebell",     muscle:"Dos",                detail:"Grand dorsal, trapèzes, biceps"},
  {id:130,name:"Clean & Press kettlebell",         muscle:"Cardio / Full body", detail:"Chaîne postérieure, deltoïdes, triceps, gainage"},
  {id:131,name:"Turkish Get-Up",                   muscle:"Épaules",            detail:"Épaules, gainage profond, fessiers, hanches"},
  {id:132,name:"Farmer Walk kettlebell",           muscle:"Avant-bras",         detail:"Avant-bras, trapèzes, gainage, quadriceps"},
  {id:133,name:"Russian Twist kettlebell",         muscle:"Abdominaux",         detail:"Abdominaux, obliques"},
  // Élastiques
  {id:134,name:"Squat avec bande",                 muscle:"Quadriceps",         detail:"Quadriceps, fessiers"},
  {id:135,name:"Hip Thrust avec bande",            muscle:"Fessiers",           detail:"Fessiers, ischios-jambiers"},
  {id:136,name:"Tirage horizontal élastique",      muscle:"Dos",                detail:"Grand dorsal, rhomboïdes, biceps"},
  {id:137,name:"Face Pull élastique",              muscle:"Épaules",            detail:"Trapèzes moyens, deltoïdes postérieurs"},
  {id:138,name:"Curl biceps élastique",            muscle:"Biceps",             detail:"Biceps"},
  {id:139,name:"Extension triceps élastique",      muscle:"Triceps",            detail:"Triceps"},
  {id:140,name:"Développé poitrine élastique",     muscle:"Pectoraux",          detail:"Pectoraux, triceps"},
  {id:141,name:"Élévations latérales élastique",   muscle:"Épaules",            detail:"Deltoïdes moyens"},
  {id:142,name:"Pallof Press",                     muscle:"Abdominaux",         detail:"Gainage, obliques, transverse"},
  {id:143,name:"Monster Walk",                     muscle:"Fessiers",           detail:"Moyen fessier, stabilisateurs de hanche"},
  {id:144,name:"Fentes avant",                     muscle:"Quadriceps",         detail:"Quadriceps, fessiers, ischios-jambiers"},
  {id:145,name:"Crunch inversé",                   muscle:"Abdominaux",         detail:"Abdominaux inférieurs, transverse"},
  {id:146,name:"Rowing buste penché haltères",     muscle:"Dos",                detail:"Grand dorsal, trapèzes, rhomboïdes, biceps, deltoïdes postérieurs"},
  {id:147,name:"Fentes marchées haltères",         muscle:"Quadriceps",         detail:"Quadriceps, fessiers, ischios-jambiers, mollets"},
  {id:148,name:"Tirage vertical élastique",        muscle:"Dos",                detail:"Grand dorsal, biceps, rhomboïdes"},
  {id:149,name:"Fentes élastique",                 muscle:"Quadriceps",         detail:"Quadriceps, fessiers, ischios-jambiers"},
  {id:150,name:"Snatch kettlebell",                muscle:"Cardio / Full body", detail:"Épaules, dos, fessiers, jambes, coordination, cardio"},
  {id:151,name:"Dips sur banc",                    muscle:"Triceps",            detail:"Triceps, pectoraux, deltoïdes antérieurs"},
  {id:152,name:"Tractions australiennes",          muscle:"Dos",                detail:"Grand dorsal, biceps, trapèzes, rhomboïdes"},
  {id:153,name:"Toes to bar",                      muscle:"Abdominaux",         detail:"Abdominaux inférieurs, fléchisseurs de hanche, gainage, épaules"},
];

const TABATA_EX_BASE = [
  {id:301, name:"Burpees",                  muscle:"Cardio / Full body"},
  {id:302, name:"Mountain climbers",        muscle:"Cardio / Full body"},
  {id:303, name:"Jumping jacks",            muscle:"Cardio / Full body"},
  {id:304, name:"Montées de genoux",        muscle:"Cardio / Full body"},
  {id:305, name:"Burpees sans saut",        muscle:"Cardio / Full body"},
  {id:306, name:"Sprint sur place",         muscle:"Cardio / Full body"},
  {id:307, name:"Talons fesses",            muscle:"Cardio / Full body"},
  {id:308, name:"Sauts sur place",          muscle:"Cardio / Full body"},
  {id:309, name:"Corde à sauter (simulée)", muscle:"Cardio / Full body"},
  {id:310, name:"Box step-up (chaise)",     muscle:"Cardio / Full body"},
  {id:320, name:"Pompes classiques",        muscle:"Pectoraux"},
  {id:321, name:"Pompes diamant",           muscle:"Triceps"},
  {id:322, name:"Pompes larges",            muscle:"Pectoraux"},
  {id:323, name:"Pompes déclinées",         muscle:"Pectoraux"},
  {id:324, name:"Pompes Spiderman",         muscle:"Pectoraux"},
  {id:325, name:"Pompes claquées",          muscle:"Pectoraux"},
  {id:326, name:"Pompes sur genoux",        muscle:"Pectoraux"},
  {id:327, name:"Dips sur chaise",          muscle:"Triceps"},
  {id:340, name:"Squats",                   muscle:"Quadriceps"},
  {id:341, name:"Squat jump",               muscle:"Quadriceps"},
  {id:342, name:"Squat sumo",               muscle:"Quadriceps"},
  {id:343, name:"Squat pulse",              muscle:"Quadriceps"},
  {id:344, name:"Fentes alternées",         muscle:"Quadriceps"},
  {id:345, name:"Fentes sautées",           muscle:"Quadriceps"},
  {id:346, name:"Fentes latérales",         muscle:"Quadriceps"},
  {id:347, name:"Step-up sur chaise",       muscle:"Quadriceps"},
  {id:348, name:"Squat isométrique mur",    muscle:"Quadriceps"},
  {id:360, name:"Donkey kicks",             muscle:"Fessiers"},
  {id:361, name:"Pont fessier",             muscle:"Fessiers"},
  {id:363, name:"Hip thrust au sol",        muscle:"Fessiers"},
  {id:365, name:"Kickback debout",          muscle:"Fessiers"},
  {id:380, name:"Crunch classique",         muscle:"Abdominaux"},
  {id:381, name:"Bicycle crunch",           muscle:"Abdominaux"},
  {id:382, name:"Planche",                  muscle:"Abdominaux"},
  {id:383, name:"Planche latérale",         muscle:"Abdominaux"},
  {id:384, name:"Relevé de jambes",         muscle:"Abdominaux"},
  {id:385, name:"Russian twist",            muscle:"Abdominaux"},
  {id:386, name:"Dead bug",                 muscle:"Abdominaux"},
  {id:387, name:"Crunch obliques",          muscle:"Abdominaux"},
  {id:388, name:"Scissors (ciseaux)",       muscle:"Abdominaux"},
  {id:389, name:"Planche dynamique",        muscle:"Abdominaux"},
  {id:390, name:"Sit-ups",                  muscle:"Abdominaux"},
  {id:391, name:"Abdominaux portefeuille",  muscle:"Abdominaux"},
  {id:392, name:"Chandelle",                muscle:"Abdominaux"},
  {id:393, name:"Touche talons",            muscle:"Abdominaux"},
  {id:394, name:"Planche superman",         muscle:"Abdominaux"},
  {id:395, name:"Abdominaux coude genou croisés", muscle:"Abdominaux"},
  {id:396, name:"Fentes avant",                   muscle:"Quadriceps"},
  {id:397, name:"Crunch inversé",                 muscle:"Abdominaux"},
];

// ─── GUIDE MOUVEMENTS ─────────────────────────────────────────────────────────
const EXERCISE_GUIDE = {
  "Développé couché barre": {steps:["Allongé sur le banc, pieds à plat au sol, omoplates serrées", "Saisir la barre légèrement plus large que les épaules, prise pronation", "Descendre la barre en arc vers le bas de la poitrine, coudes à 45–75°", "Pousser jusqu'à extension complète en expirant"],tips:"Garde les fessiers et le dos en contact avec le banc. La barre doit frôler la poitrine sans rebondir."},
  "Développé couché haltères": {steps:["Assis sur le banc, haltères sur les cuisses, puis allongé en les amenant aux épaules", "Bras à 75°, haltères au niveau de la poitrine, paumes vers l'avant", "Pousser les haltères vers le haut en les rapprochant légèrement en haut", "Redescendre lentement jusqu'à l'étirement pectoral"],tips:"Les haltères offrent plus d'amplitude que la barre. Profites-en pour descendre un peu plus bas."},
  "Développé incliné barre": {steps:["Banc incliné à 30–45°, dos plaqué contre le dossier", "Saisir la barre plus large que les épaules", "Descendre la barre vers le haut de la poitrine / clavicules", "Pousser verticalement jusqu'à l'extension"],tips:"Plus l'inclinaison est forte, plus le deltoïde antérieur travaille. 30° cible mieux le haut des pectoraux."},
  "Développé incliné haltères": {steps:["Banc incliné à 30–45°, haltères en position de départ aux épaules", "Descendre les haltères sur les côtés de la poitrine en contrôlant", "Pousser en rapprochant légèrement les haltères en haut", "Garder une légère flexion des coudes tout au long"],tips:"L'amplitude est plus grande qu'avec la barre. Descends jusqu'à sentir l'étirement sans douleur aux épaules."},
  "Développé décliné barre": {steps:["Banc décliné, pieds bloqués sous les rouleaux", "Saisir la barre légèrement plus large que les épaules", "Descendre vers le bas des pectoraux / sternum", "Pousser en expirant jusqu'à l'extension"],tips:"Cet angle cible le faisceau sternal (bas des pectoraux). Moins de stress sur les épaules qu'à plat."},
  "Développé décliné haltères": {steps:["Banc décliné, haltères en position haute", "Descendre les haltères sur les côtés du bas de la poitrine", "Pousser vers le haut en expirant", "Garder les coudes légèrement fléchis en haut"],tips:"Mouvement idéal pour définir le bas des pectoraux. Contrôle bien la descente."},
  "Écarté haltères plat": {steps:["Allongé sur le banc plat, haltères en haut, bras quasi tendus", "Ouvrir les bras en arc large en inspirant, coudes légèrement fléchis", "Descendre jusqu'à sentir l'étirement des pectoraux", "Refermer en expirant comme pour enlacer un tonneau"],tips:"Ce n'est pas un exercice de force, privilégie des charges légères et l'amplitude maximale."},
  "Écarté haltères incliné": {steps:["Banc incliné à 30°, haltères en haut", "Ouvrir les bras en arc en inspirant", "Descendre jusqu'à l'étirement du haut des pectoraux", "Refermer lentement en expirant"],tips:"Garde une légère flexion des coudes constante pour protéger l'articulation."},
  "Pec deck (papillon machine)": {steps:["Assis, dos plaqué contre le dossier, avant-bras contre les coussins", "Amener les coussins l'un vers l'autre en expirant", "Maintenir une seconde en position de contraction maximale", "Laisser revenir lentement en contrôlant"],tips:"Excellent exercice d'isolation pour finir une séance pectoraux. Concentre-toi sur la contraction."},
  "Écarté à la poulie haute": {steps:["Debout entre deux poulies hautes, une poignée dans chaque main", "Légèrement penché en avant, bras ouverts sur les côtés", "Amener les poignées en bas et devant toi en arc", "Maintenir la contraction une seconde avant de revenir"],tips:"Ce mouvement cible le bas des pectoraux. Garde le torse stable, seuls les bras bougent."},
  "Écarté à la poulie basse": {steps:["Debout entre deux poulies basses, poignées en bas", "Légèrement penché en avant, bras ouverts", "Amener les poignées en haut et devant toi en arc", "Contrôler la descente"],tips:"Cible le haut des pectoraux et les deltoïdes antérieurs. Maintiens une légère flexion des coudes."},
  "Pompes": {steps:["Position de planche, mains légèrement plus larges que les épaules", "Corps gainé, tête dans l'axe de la colonne", "Descendre la poitrine vers le sol en fléchissant les coudes à 45°", "Pousser jusqu'à l'extension sans verrouiller les coudes"],tips:"Les pompes sont un mouvement complet : pectoraux, triceps, deltoïdes et gainage abdominal."},
  "Pompes déclinées": {steps:["Pieds surélevés sur un banc ou une boîte, mains au sol", "Corps en ligne droite, gainage actif", "Descendre la poitrine vers le sol", "Pousser jusqu'à l'extension"],tips:"Plus les pieds sont hauts, plus le haut des pectoraux et les deltoïdes antérieurs sont sollicités."},
  "Dips lestés": {steps:["Mains sur deux barres parallèles, bras tendus, corps vertical", "Se pencher légèrement en avant pour cibler les pectoraux", "Descendre jusqu'à ce que les coudes soient à 90°", "Pousser jusqu'à l'extension complète"],tips:"Poids trop lourd = épaules en danger. Commence sans lest et ajoute progressivement."},
  "Pull-over haltère": {steps:["Allongé perpendiculairement au banc, épaules posées dessus", "Tenir un haltère à deux mains au-dessus de la poitrine", "Descendre l'haltère en arc derrière la tête en inspirant", "Remonter en expirant, bras quasi tendus"],tips:"Mouvement unique qui étire simultanément les pectoraux, le grand dorsal et le dentelé."},
  "Tractions pronation large": {steps:["Saisir la barre plus large que les épaules, paumes vers l'avant", "Déprimer les omoplates avant de tirer", "Tirer le menton au-dessus de la barre en écartant les coudes", "Redescendre lentement jusqu'à l'extension complète des bras"],tips:"Initie le mouvement par les omoplates, pas par les bras. Évite de te balancer."},
  "Tractions supination serrée": {steps:["Saisir la barre à largeur d'épaules, paumes vers soi", "Tirer jusqu'à ce que le menton dépasse la barre", "Coudes proches du corps pendant la montée", "Redescendre lentement"],tips:"La prise supination est plus facile et sollicite davantage les biceps. Parfaite pour débuter."},
  "Tractions neutres": {steps:["Saisir deux barres parallèles (prise neutre, paumes se faisant face)", "Tirer jusqu'à ce que le menton dépasse les mains", "Garder les coudes proches du corps", "Redescendre lentement"],tips:"Plus douce pour les poignets et les coudes. Excellent équilibre entre dorsal et biceps."},
  "Tractions lestées": {steps:["Fixer un lest (ceinture lestée, gilet ou haltère entre les pieds) avant de saisir la barre", "Saisir la barre en prise pronation à largeur d'épaules ou plus large", "Déprimer les omoplates, puis tirer le menton au-dessus de la barre en ramenant les coudes vers le bas", "Maintenir une seconde en haut", "Redescendre lentement jusqu'à l'extension complète des bras"],tips:"N'ajoute du lest que lorsque tu réalises 10+ tractions propres sans aide. L'ajout de charge amplifie les erreurs techniques — reste strict sur la forme."},
  "Rowing barre pronation": {steps:["Debout, buste penché à environ 45°, dos plat, genoux légèrement fléchis", "Saisir la barre plus large que les épaules, prise pronation", "Tirer la barre vers le nombril en serrant les omoplates", "Redescendre lentement jusqu'à l'extension des bras"],tips:"Le dos doit rester plat et ne pas s'arrondir. Engage le gainage abdominal tout au long."},
  "Rowing barre supination": {steps:["Mêmes points de départ qu'en pronation, mais prise supination (paumes vers le haut)", "Buste à 45°, dos plat", "Tirer la barre vers le bas du ventre / hanches", "Serrer les omoplates en fin de mouvement"],tips:"La prise supination cible davantage le grand dorsal et les biceps. Amplitude souvent meilleure."},
  "Rowing haltère unilatéral": {steps:["Un genou et une main sur le banc, dos parallèle au sol", "Haltère dans la main libre, bras tendu", "Tirer l'haltère vers la hanche en gardant le coude proche du corps", "Redescendre lentement jusqu'à l'extension"],tips:"Visualise que tu rentres ton coude dans ta poche. Évite de faire tourner le torse."},
  "Rowing câble assis": {steps:["Assis face à la poulie, pieds sur les appuis, genoux légèrement fléchis", "Saisir la poignée en V ou à deux mains", "Tirer vers le bas du ventre en serrant les omoplates", "Revenir lentement en laissant le dos s'étirer légèrement"],tips:"Ne pas arrondir le bas du dos pour chercher de l'amplitude. L'étirement doit venir des omoplates."},
  "Rowing machine Hammer": {steps:["Assis face à la machine, poitrine contre l'appui", "Saisir les poignées neutres", "Tirer en ramenant les coudes en arrière", "Revenir lentement à l'extension"],tips:"La machine stabilise le torse : concentre-toi sur la contraction du dos et non sur l'élan."},
  "Tirage vertical prise large": {steps:["Assis, genoux sous les rouleaux, dos légèrement incliné en arrière", "Saisir la barre plus large que les épaules, prise pronation", "Tirer vers le haut de la poitrine en déprimant les omoplates", "Revenir lentement à l'extension complète"],tips:"Initie par les omoplates, pas par les bras. Évite de te pencher trop en arrière."},
  "Tirage vertical prise serrée": {steps:["Même position que tirage large mais prise serrée ou prise neutre", "Tirer la barre ou la poignée vers le sternum", "Coudes restent proches du corps", "Revenir lentement"],tips:"La prise serrée implique davantage les biceps et cible la zone médiane du dos."},
  "Tirage horizontal prise large": {steps:["Assis à la machine à câble horizontal", "Saisir la barre large, dos droit", "Tirer vers l'abdomen en serrant les omoplates", "Revenir lentement"],tips:"Cible les rhomboïdes et les trapèzes moyens. Pince bien les omoplates en fin de mouvement."},
  "Tirage horizontal prise serrée": {steps:["Même position que tirage horizontal large mais poignée en V serrée", "Tirer vers le bas de la poitrine", "Serrer les omoplates en fin de mouvement", "Revenir lentement"],tips:"Cible davantage le grand dorsal. Garde le dos droit tout au long."},
  "Soulevé de terre": {steps:["Pieds écartés à largeur de hanche, barre au-dessus des orteils", "Saisir la barre, dos plat, hanches fléchies, regard vers l'avant", "Pousser le sol loin de soi : extension simultanée des genoux et des hanches", "Redresser complètement, puis redescendre en contrôlant"],tips:"La barre doit raser les tibias et les cuisses. Un dos arrondi sous charge est dangereux."},
  "Soulevé de terre roumain": {steps:["Debout, barre ou haltères devant les cuisses", "Pousser les hanches en arrière en gardant les jambes quasi tendues", "Descendre le long des jambes jusqu'à sentir l'étirement des ischio-jambiers", "Remonter en contractant les fessiers et les ischios"],tips:"Mouvement de hanche pur, pas de squat. Les genoux restent légèrement fléchis mais fixes."},
  "Soulevé de terre sumo": {steps:["Pieds très écartés, orteils pointés vers l'extérieur", "Saisir la barre à l'intérieur des jambes, dos plat", "Pousser le sol en étendant genoux et hanches simultanément", "Se redresser complètement en contractant les fessiers"],tips:"Le sumo réduit le trajet de la barre. Idéal si tu as des jambes longues ou peu de mobilité lombaire."},
  "Good morning": {steps:["Barre sur les trapèzes comme pour un squat, pieds écartés", "Pousser les hanches en arrière en gardant le dos droit", "Descendre jusqu'à ce que le dos soit quasi horizontal", "Remonter en contractant les érecteurs et les fessiers"],tips:"Exercice technique à ne pas charger lourd avant de maîtriser la posture. Risque lombaire si mal exécuté."},
  "Pull-over poulie haute": {steps:["Agenouillé face à la poulie haute, poignée ou corde en main", "Bras tendus en avant, torse droit", "Amener les bras vers le bas et l'arrière en arc", "Contrôler le retour"],tips:"Excellente isolation du grand dorsal. Garde les bras quasi tendus et initie par les omoplates."},
  "Développé militaire barre": {steps:["Debout ou assis, barre au niveau des clavicules, prise légèrement plus large que les épaules", "Contracte fessiers et abdos pour protéger le lombaire", "Pousser la barre verticalement au-dessus de la tête", "Redescendre lentement jusqu'aux clavicules"],tips:"Évite d'arquer le bas du dos. Si tu ne peux pas rester droit, la charge est trop lourde."},
  "Développé militaire haltères": {steps:["Assis ou debout, haltères au niveau des oreilles, coudes à 90°", "Pousser les haltères vers le haut en les rapprochant légèrement", "Extension complète sans verrouiller les coudes", "Redescendre lentement"],tips:"Les haltères permettent plus de liberté de mouvement et corrigent les déséquilibres gauche-droite."},
  "Développé Arnold": {steps:["Haltères devant le visage, paumes vers toi, coudes fléchis (position de départ curl)", "En poussant vers le haut, faire pivoter les haltères de l'intérieur vers l'extérieur", "Arriver en haut avec les paumes vers l'avant, bras tendus", "Inverser le mouvement en redescendant"],tips:"Mouvement créé par Arnold Schwarzenegger. Sollicite les trois faisceaux du deltoïde."},
  "Élévations latérales haltères": {steps:["Debout, haltères le long du corps, légère flexion des coudes", "Lever les bras sur les côtés jusqu'à hauteur des épaules", "Pencher légèrement le petit doigt vers le haut (position de la théière)", "Redescendre lentement en 3–4 secondes"],tips:"Exercice d'isolation pur. Charges légères et contrôle total valent mieux que lourd et balancé."},
  "Élévations latérales câble": {steps:["Debout à côté d'une poulie basse, la poignée dans la main extérieure", "Lever le bras sur le côté jusqu'à hauteur d'épaule", "Garder une légère flexion du coude constante", "Contrôler la descente"],tips:"La tension est constante tout au long du mouvement contrairement aux haltères. Très efficace."},
  "Élévations frontales haltères": {steps:["Debout, haltères devant les cuisses, prise pronation ou neutre", "Lever un bras (ou les deux) devant soi jusqu'à hauteur des yeux", "Garder le bras quasi tendu", "Redescendre lentement"],tips:"Cible le deltoïde antérieur. Attention à ne pas compenser avec le dos."},
  "Élévations frontales câble": {steps:["Debout dos à la poulie basse, poignée dans la main", "Lever le bras devant soi jusqu'à hauteur des yeux", "Tension constante grâce au câble", "Contrôler la descente"],tips:"La poulie basse maintient la tension même en bas du mouvement, contrairement aux haltères."},
  "Oiseau haltères deltoïdes post": {steps:["Assis sur un banc, penché en avant, buste quasi horizontal", "Haltères pendants sous la poitrine, coudes légèrement fléchis", "Ouvrir les bras sur les côtés en arc jusqu'à hauteur des épaules", "Contrôler la descente"],tips:"Muscles postérieurs de l'épaule souvent négligés mais essentiels pour l'équilibre articulaire."},
  "Oiseau câble deltoïdes post": {steps:["Debout face à deux poulies hautes croisées", "Saisir la poignée gauche avec la main droite et vice versa", "Tirer les bras en arrière et sur les côtés", "Contrôler le retour"],tips:"La double poulie maintient la tension sur tout l'arc. Excellent pour les deltoïdes postérieurs."},
  "Face pull câble": {steps:["Debout face à une poulie haute avec corde", "Tirer la corde vers le visage en écartant les mains", "Les coudes s'élèvent au-dessus des épaules", "Revenir lentement"],tips:"Exercice clé pour la santé des épaules. Cible les rotateurs externes et les deltoïdes postérieurs."},
  "Tirage menton barre": {steps:["Debout, barre en prise pronation à largeur épaules", "Lever la barre jusqu'au menton en écartant les coudes vers le haut", "Les coudes doivent dépasser la barre au point haut", "Redescendre lentement"],tips:"Ne monte pas trop haut et évite la prise trop serrée pour préserver les épaules."},
  "Tirage menton câble": {steps:["Mêmes points techniques mais à la poulie basse avec barre droite ou EZ", "La tension est plus constante qu'avec la barre libre", "Monter jusqu'au menton", "Contrôler la descente"],tips:"La poulie offre une résistance plus douce en bas du mouvement. Bonne alternative à la barre."},
  "Curl barre droite": {steps:["Debout, barre en prise supination, coudes collés au corps", "Fléchir les coudes en remontant la barre vers les épaules", "Contracter les biceps en haut", "Redescendre lentement jusqu'à l'extension complète"],tips:"Coudes fixes, le mouvement vient uniquement de la flexion du coude. Pas de balancement du torse."},
  "Curl barre EZ": {steps:["Même technique que le curl barre droite", "La barre EZ permet une prise semi-pronation qui réduit la tension sur les poignets", "Fléchir jusqu'aux épaules", "Redescendre lentement"],tips:"Si tu as des douleurs aux poignets avec la barre droite, la barre EZ est ta meilleure option."},
  "Curl haltères simultané": {steps:["Debout ou assis, haltères en supination le long du corps", "Fléchir les deux bras simultanément", "Supiner (tourner la paume vers le haut) si tu pars en prise neutre", "Redescendre lentement"],tips:"La supination en cours de mouvement amplifie la contraction du biceps brachial."},
  "Curl haltères alterné": {steps:["Debout, un haltère dans chaque main", "Monter un bras pendant que l'autre est en bas", "Alterner en contrôlant chaque répétition", "Garder les coudes fixes le long du corps"],tips:"L'alternance permet de se concentrer sur chaque bras individuellement."},
  "Curl marteau": {steps:["Debout ou assis, haltères en prise neutre (comme un marteau)", "Fléchir le coude sans faire pivoter le poignet", "Monter jusqu'à 90° ou plus", "Redescendre lentement"],tips:"Cible le brachial antérieur et le brachioradial en plus du biceps. Excellent pour l'épaisseur du bras."},
  "Curl marteau câble corde": {steps:["Poulie basse avec corde, en prise neutre", "Fléchir les coudes en tirant la corde vers les épaules", "Garder les coudes fixes", "Revenir lentement"],tips:"La corde permet une tension constante. Écarte légèrement les deux côtés de la corde en haut."},
  "Curl concentration": {steps:["Assis sur un banc, coude appuyé sur la face interne de la cuisse, torse légèrement penché vers la jambe", "Haltère dans la main, bras tendu vers le sol", "Fléchir lentement l'avant-bras vers l'épaule en supinant le poignet", "Contracter au maximum en haut — maintenir 1 seconde", "Redescendre lentement jusqu'à l'extension complète"],tips:"Mouvement d'isolation pure. L'appui sur la cuisse fixe le bras et empêche tout élan. Idéal pour finir une séance biceps et accentuer le pic musculaire."},
  "Curl pupitre Scott barre EZ": {steps:["Assis au pupitre Scott, bras appuyés sur le coussin incliné", "Barre EZ en supination, bras tendus", "Fléchir jusqu'à environ 90° (ne pas monter trop haut)", "Redescendre lentement jusqu'à l'extension complète"],tips:"Le pupitre empêche tout élan. Excellent pour isoler le biceps brachial et développer le pic."},
  "Curl incliné haltères": {steps:["Assis sur banc incliné à 45–60°, bras pendant vers le bas", "Fléchir les deux bras en supinant", "Contraction maximale en haut", "Redescendre lentement"],tips:"L'inclinaison pré-étire le biceps en bas du mouvement. Amplitude et étirement maximaux."},
  "Curl câble poulie basse": {steps:["Face à la poulie basse, poignée en supination", "Fléchir le coude, bras fixe le long du corps", "Contraction maximale en haut", "Revenir lentement à l'extension"],tips:"La tension reste constante tout au long du mouvement. Parfait en fin de séance."},
  "Curl poulie haute": {steps:["Face à une poulie haute, bras tendu vers la poulie", "Fléchir le coude pour ramener la main vers l'oreille", "Maintenir la contraction une seconde", "Revenir lentement"],tips:"Excellente isolation du biceps en position contractée. Varie l'angle pour cibler différentes fibres."},
  "Développé couché prise serrée": {steps:["Allongé sur le banc plat, prise serrée (mains à 30–40 cm)", "Descendre la barre vers le bas de la poitrine, coudes proches du corps", "Pousser jusqu'à l'extension", "Redescendre lentement"],tips:"La prise serrée transfère le travail sur les triceps et le faisceau sternal. Évite une prise trop serrée."},
  "Barre au front Skull crusher": {steps:["Allongé sur banc, barre ou barre EZ bras tendus au-dessus du visage", "Fléchir uniquement les coudes pour descendre la barre vers le front", "Coudes fixes et pointés vers le plafond", "Pousser jusqu'à l'extension"],tips:"Mouvements des coudes uniquement. Pas trop lourd au risque de compromettre les coudes."},
  "Extension nuque haltère": {steps:["Assis ou debout, haltère tenu à deux mains au-dessus de la tête", "Fléchir les coudes pour descendre l'haltère derrière la tête", "Coudes serrés et pointés vers le plafond", "Pousser jusqu'à l'extension complète"],tips:"Étire et renforce le chef long du triceps. Garde les coudes proches de la tête."},
  "Extension nuque barre EZ": {steps:["Assis, barre EZ tenue derrière la nuque bras fléchis", "Coudes pointés vers le haut", "Pousser jusqu'à l'extension complète", "Redescendre lentement"],tips:"La barre EZ est plus confortable pour les poignets que la barre droite en position nuque."},
  "Triceps poulie haute barre": {steps:["Debout face à la poulie haute, barre courte en main", "Coudes fixes le long du corps, légèrement en avant", "Pousser vers le bas jusqu'à extension complète", "Remonter lentement en contrôlant"],tips:"Garde les coudes immobiles tout au long. Seuls les avant-bras bougent."},
  "Triceps poulie haute corde": {steps:["Debout face à la poulie haute, corde en main", "Même position de départ que la barre", "Pousser vers le bas en écartant les deux côtés de la corde en fin de mouvement", "Remonter lentement"],tips:"L'écartement de la corde en bas maximise la contraction des triceps. Excellent exercice d'isolation."},
  "Triceps poulie basse overhead": {steps:["Face opposée à la poulie basse, corde tenue derrière la tête", "Coudes pointés vers l'avant, bras fléchis", "Pousser les bras en extension devant soi", "Revenir lentement"],tips:"Cible particulièrement le chef long du triceps en position pré-étirée. Amplitude maximale."},
  "Dips triceps barres parallèles": {steps:["Corps droit (pas penché en avant comme pour les pectoraux)", "Descendre jusqu'à 90° de flexion des coudes", "Pousser jusqu'à l'extension complète", "Coudes proches du corps pendant tout le mouvement"],tips:"Corps vertical = triceps. Corps penché en avant = pectoraux. Choisir selon ton objectif."},
  "Kickback haltère": {steps:["Torse penché en avant à 90°, bras fléchi à 90° le long du corps", "Étendre le bras vers l'arrière jusqu'à l'extension complète", "Maintenir la contraction une seconde", "Revenir lentement"],tips:"La charge doit être légère pour une exécution parfaite. L'élan annule l'efficacité."},
  "Extension haltère allongé": {steps:["Allongé sur banc, haltère tenu à une ou deux mains au-dessus du visage", "Fléchir uniquement les coudes pour descendre vers le front ou la nuque", "Pousser jusqu'à l'extension complète", "Coudes fixes et stables"],tips:"Alternative aux skull crushers. Contrôle la trajectoire pour protéger les coudes."},
  "Pompes diamant": {steps:["Position de planche, mains formant un triangle (index et pouces se touchent)", "Corps gainé, descendre en gardant les coudes proches du corps", "Descendre la poitrine jusqu'aux mains", "Pousser jusqu'à l'extension"],tips:"Les pompes diamant sont l'un des meilleurs exercices au poids du corps pour les triceps."},
  "Tirage corde triceps unilatéral": {steps:["Poulie haute, poignée simple dans une main", "Coude fixe le long du corps", "Pousser vers le bas jusqu'à l'extension complète", "Remonter lentement"],tips:"L'unilatéral permet de corriger les déséquilibres et de se concentrer sur chaque bras."},
  "Squat barre low bar": {steps:["Barre posée bas sur les trapèzes (et non sur la nuque)", "Pieds écartés, orteils légèrement ouverts, stance adapté à ta morphologie", "Descendre en poussant les genoux dans l'axe des pieds, hanches en arrière", "Remonter en poussant fort dans le sol jusqu'à l'extension"],tips:"Le low bar permet des charges plus lourdes. Le torse s'incline davantage qu'au front squat."},
  "Squat barre Smith machine": {steps:["Barre fixée sur rails de la Smith machine, pieds légèrement en avant", "Déverrouiller la barre, descendre jusqu'à la parallèle", "Remonter jusqu'à l'extension", "Reverrouiller à la fin"],tips:"La machine guide la barre mais ne protège pas automatiquement le dos. Maintiens la bonne posture."},
  "Squat avant front squat": {steps:["Barre posée sur les deltoïdes antérieurs, coudes hauts et pointés vers l'avant", "Pieds à largeur d'épaules, orteils légèrement ouverts", "Descendre en gardant le torse le plus vertical possible", "Remonter en poussant dans le sol"],tips:"Les coudes hauts sont essentiels pour maintenir la barre en place. Mobilité des poignets et chevilles requise."},
  "Squat gobelet": {steps:["Tenir un kettlebell ou haltère devant la poitrine à deux mains", "Pieds à largeur d'épaules, orteils ouverts", "Descendre profond en gardant les talons au sol", "Remonter en poussant"],tips:"Excellent exercice d'apprentissage du squat. Le contre-poids aide à garder le torse droit."},
  "Squat bulgare split squat": {steps:["Un pied posé sur un banc derrière soi, l'autre devant", "Descendre sur la jambe avant jusqu'à la parallèle", "Genou avant dans l'axe du pied, ne pas dépasser trop les orteils", "Remonter en poussant avec le talon avant"],tips:"Excellent pour corriger les déséquilibres. Pied avant assez loin pour que le genou ne dépasse pas trop."},
  "Squat sumo": {steps:["Très grand écart de pieds, orteils pointés vers l'extérieur (45°)", "Descendre en poussant les genoux vers l'extérieur", "Garder le dos droit et le regard vers l'avant", "Remonter en contractant les fessiers et les adducteurs"],tips:"Cible davantage les adducteurs et les fessiers que le squat classique."},
  "Leg press 45°": {steps:["Assis dans la machine, pieds à largeur d'épaules sur la plateforme", "Déverrouiller les sécurités, fléchir les genoux jusqu'à 90°", "Pousser la plateforme jusqu'à presque l'extension (ne pas verrouiller)", "Contrôler la descente"],tips:"Ne jamais verrouiller les genoux en haut. Pieds plus hauts = plus de fessiers et ischios."},
  "Leg press horizontal": {steps:["Assis dans la machine horizontale, pieds sur la plateforme", "Fléchir les genoux en amenant la plateforme vers soi", "Pousser jusqu'à presque l'extension", "Contrôler la descente"],tips:"Moins de compression lombaire que le leg press 45°. Bon pour les personnes avec des problèmes de dos."},
  "Hack squat machine": {steps:["Épaules sous les épaulières, pieds sur la plateforme", "Descendre en fléchissant les genoux jusqu'à 90° ou plus", "Pousser jusqu'à presque l'extension", "Contrôler la descente"],tips:"Cible intensément les quadriceps. Pieds bas et serrés pour maximiser le travail des quadris."},
  "Extension quadriceps machine": {steps:["Assis sur la machine, chevilles sous les rouleaux", "Étendre les jambes jusqu'à la quasi-extension", "Maintenir une seconde en contraction", "Redescendre lentement"],tips:"Exercice d'isolation pur pour les quadriceps. Excellent pour finir une séance jambes."},
  "Fentes avant haltères": {steps:["Debout, un haltère dans chaque main", "Faire un grand pas en avant", "Descendre le genou arrière vers le sol", "Remonter en poussant avec le talon avant"],tips:"Garde le torse droit et le regard vers l'avant. Le genou avant ne doit pas dépasser trop les orteils."},
  "Fentes arrière reverse lunge": {steps:["Debout, un haltère dans chaque main ou barre sur les épaules", "Faire un grand pas en arrière", "Descendre le genou arrière vers le sol", "Remonter sur la jambe avant"],tips:"Plus stable que la fente avant. Moins de stress sur le genou avant. Idéale pour les débutants."},
  "Fentes latérales": {steps:["Debout, faire un grand pas sur le côté", "Fléchir le genou de la jambe qui part sur le côté", "Garder l'autre jambe tendue", "Pousser pour revenir en position initiale"],tips:"Cible les adducteurs et les fessiers latéraux. Garder le dos droit tout au long."},
  "Fentes à la barre guidée": {steps:["Barre sur les épaules à la Smith machine", "Faire un grand pas en avant ou en arrière", "Descendre jusqu'à 90° de flexion du genou avant", "Remonter en poussant"],tips:"La barre guidée aide à stabiliser le mouvement. Bon pour se concentrer sur la technique."},
  "Leg curl couché machine": {steps:["Allongé face vers le bas sur la machine, chevilles sous les rouleaux", "Fléchir les genoux pour ramener les talons vers les fessiers", "Contraction maximale en haut", "Redescendre lentement"],tips:"Cible les ischio-jambiers. Garde les hanches plaquées contre la machine, ne les soulève pas."},
  "Leg curl assis machine": {steps:["Assis sur la machine, jambes tendues sous les rouleaux supérieurs", "Fléchir les genoux pour descendre les rouleaux", "Contraction maximale en bas", "Redescendre lentement"],tips:"La position assise étire davantage le chef court des ischio-jambiers. Bonne variation."},
  "Leg curl debout unilatéral": {steps:["Debout face à la machine, une cheville sous le rouleau", "Fléchir le genou pour ramener le talon vers le fessier", "Contraction maximale", "Redescendre lentement"],tips:"L'unilatéral permet de corriger les déséquilibres entre les deux jambes."},
  "Nordic curl GHR": {steps:["Agenouillé, pieds bloqués sous un rouleau ou par un partenaire", "Corps droit, contracter les ischio-jambiers", "Descendre le torse vers le sol en freinant avec les ischios", "Remonter en contractant les ischios ou en s'aidant des mains"],tips:"Exercice très intense pour les ischio-jambiers. Commence par des négatifs lents si trop difficile."},
  "Soulevé de terre jambes raides": {steps:["Debout, barre ou haltères en avant des cuisses", "Pousser les hanches en arrière, jambes quasi tendues", "Descendre le long des jambes jusqu'à l'étirement des ischios", "Remonter en contractant les ischios et les fessiers"],tips:"Similaire au soulevé de terre roumain. La différence : les genoux sont encore plus tendus."},
  "Curl ischios câble debout": {steps:["Debout face à la poulie basse, cheville dans la sangle", "Fléchir le genou pour ramener le talon vers le fessier", "Contraction maximale", "Redescendre lentement"],tips:"Excellent pour cibler les ischios en fin de séance. Garde la cuisse fixe et le dos droit."},
  "Glute ham raise": {steps:["S'installer sur le banc GHR, pieds bloqués sous les rouleaux, genoux posés sur le coussin", "Corps en position horizontale, bras croisés sur la poitrine", "Contracter les ischio-jambiers et les fessiers pour ramener le torse vers le haut", "Monter jusqu'à la verticalité ou légèrement au-delà", "Redescendre lentement en freinant avec les ischios — c'est la phase la plus efficace", "S'aider des mains pour remonter si nécessaire"],tips:"Un des exercices les plus complets pour les ischio-jambiers et les fessiers. La descente excentrique lente est plus importante que la montée. Commence avec l'aide des bras au retour jusqu'à gagner en force."},
  "Hip thrust barre": {steps:["Dos appuyé sur un banc (hauteur des omoplates), barre sur les hanches", "Pieds à plat au sol, genoux fléchis à 90°, menton rentré", "Pousser les hanches vers le haut en contractant les fessiers", "Maintenir une seconde en haut, redescendre lentement"],tips:"La poussée se fait par les talons. Menton rentré pour protéger le cou. Le dos reste droit."},
  "Hip thrust machine": {steps:["Assis dans la machine hip thrust, dos contre le dossier", "Pieds sur les appuis, hanches sous le coussin", "Pousser les hanches vers le haut", "Revenir lentement"],tips:"La machine stabilise le mouvement. Mêmes principes que le hip thrust barre."},
  "Hip thrust unilatéral": {steps:["Dos sur banc, une jambe tendue ou pliée en l'air", "L'autre pied à plat au sol, hanche sous le coussin ou barre", "Pousser la hanche vers le haut avec une seule jambe", "Redescendre lentement"],tips:"Corrige les déséquilibres droite-gauche. Plus difficile à stabiliser : commence sans lest."},
  "Abduction hanche câble": {steps:["Debout de côté par rapport à la poulie basse, sangle à la cheville extérieure", "Garder le corps droit et l'appui stable", "Lever la jambe sur le côté jusqu'à 45–60°", "Contrôler la descente"],tips:"Cible le moyen fessier et le tenseur du fascia lata. Essentiel pour la stabilité du bassin."},
  "Abduction machine assise": {steps:["Assis dans la machine, genoux contre les coussins extérieurs", "Écarter les jambes contre la résistance", "Contraction maximale à l'extérieur", "Revenir lentement"],tips:"Cible les fessiers latéraux et les rotateurs externes de la hanche."},
  "Kickback câble fessiers": {steps:["Debout face à la poulie basse, sangle à la cheville", "Légèrement penché en avant, appui stable", "Pousser la jambe vers l'arrière en extension complète de la hanche", "Contrôler la descente"],tips:"Garde le mouvement contrôlé, pas d'élan. Contracte le fessier en fin de mouvement."},
  "Donkey kick quadrupédie": {steps:["À quatre pattes, dos plat, gainage actif", "Pousser une jambe vers le haut et l'arrière en fléchissant le genou à 90°", "Extension complète de la hanche en haut", "Revenir lentement"],tips:"Exercice simple mais efficace pour les fessiers. Peut se faire avec une bande de résistance."},
  "Pont fessier au sol": {steps:["Allongé sur le dos, genoux fléchis, pieds à plat au sol", "Pousser les hanches vers le haut en contractant les fessiers", "Extension complète de la hanche en haut", "Redescendre lentement"],tips:"Version accessible du hip thrust. Ajoute un poids sur les hanches pour progresser."},
  "Mollets debout machine": {steps:["Épaules sous les épaulières, avant des pieds sur la marche, talons dans le vide", "Descendre les talons le plus bas possible pour étirer", "Monter sur les pointes des pieds au maximum", "Maintenir la contraction une seconde"],tips:"Amplitude complète, de l'étirement maximal à la contraction maximale. Ne pas rebondir en bas."},
  "Mollets assis machine": {steps:["Assis, genoux sous les rouleaux, avant des pieds sur la marche", "Descendre les talons pour étirer les mollets", "Monter sur les pointes au maximum", "Contrôler la descente"],tips:"La position assise cible davantage le soléaire (sous le mollet). Complément parfait aux mollets debout."},
  "Mollets à la presse": {steps:["En position de leg press, avant des pieds au bord de la plateforme, talons dans le vide", "Pousser la plateforme avec les pointes des pieds", "Amplitude complète : étirement total puis contraction maximale", "Ne pas verrouiller les genoux"],tips:"Permet des charges importantes. Genoux légèrement fléchis pendant tout le mouvement."},
  "Mollets debout haltères": {steps:["Debout, un haltère dans chaque main ou un dans une main", "Avant des pieds sur une marche ou au sol", "Descendre les talons puis monter sur les pointes", "Amplitude maximale"],tips:"Simple et efficace. Peut se faire unilatéralement pour plus d'intensité."},
  "Mollets unilatéral escalier": {steps:["Un pied sur une marche, l'autre levé ou à l'écart", "Descendre le talon au maximum", "Monter sur la pointe au maximum", "Contrôler la descente"],tips:"L'unilatéral double la charge relative et corrige les déséquilibres. Tiens une rambarde pour l'équilibre."},
  "Crunch classique": {steps:["Allongé sur le dos, genoux fléchis, pieds au sol", "Mains derrière la nuque ou croisées sur la poitrine", "Soulever les épaules et le haut du dos en contractant les abdos", "Revenir lentement sans poser complètement"],tips:"Le mouvement est court et contrôlé. Pas de traction sur la nuque avec les mains."},
  "Crunch câble agenouillé": {steps:["Agenouillé face à la poulie haute, corde tenue derrière la nuque", "Fléchir le torse vers l'avant-bas en contractant les abdos", "Maintenir la contraction une seconde", "Revenir lentement"],tips:"Permet de surcharger les abdominaux progressivement. Excellente option pour les abdos avancés."},
  "Relevé de jambes suspendu": {steps:["Suspendu à une barre, bras tendus", "Lever les jambes tendues (ou fléchies) jusqu'à l'horizontale ou plus", "Contrôler la descente sans lâcher le gainage", "Éviter le balancement"],tips:"Cible intensément les abdos et les fléchisseurs de hanche. Très efficace mais difficile."},
  "Relevé de genoux suspendu": {steps:["Suspendu à une barre, bras tendus", "Ramener les genoux vers la poitrine en arrondissant le bas du dos", "Contraction des abdos en haut", "Redescendre lentement"],tips:"Version plus accessible du relevé de jambes. Idéal pour débuter."},
  "Planche frontale isométrique": {steps:["Position de pompe sur les avant-bras, coudes à 90°", "Corps en ligne droite : tête, épaules, hanches, talons", "Contracter abdos, fessiers et cuisses", "Maintenir la position le plus longtemps possible"],tips:"Ne creuse pas le bas du dos et ne remonte pas les fesses. Un gainage parfait fait travailler tout le corps."},
  "Gainage latéral": {steps:["Sur le côté, appui sur un avant-bras et le bord du pied", "Corps en ligne droite, hanches décollées du sol", "Gainage des obliques et des abducteurs", "Maintenir la position"],tips:"Idéal pour cibler les obliques et stabiliser le bassin. Version évoluée : levée de jambe."},
  "Russian twist": {steps:["Assis, jambes fléchies décollées du sol (ou pieds au sol pour débuter)", "Se pencher légèrement en arrière, dos droit", "Tourner le torse de gauche à droite en tenant un poids ou non", "Contrôler la rotation"],tips:"L'amplitude de la rotation doit venir du torse, pas uniquement des bras."},
  "Roue abdominale": {steps:["À genoux, mains sur la roue, dos droit", "Faire rouler la roue vers l'avant en étendant le corps", "Aller aussi loin que tu peux en gardant le contrôle", "Revenir en contractant fortement les abdos"],tips:"Exercice très difficile. Commence par une demi-amplitude. Ne pas creuser le dos en bas."},
  "Dead bug": {steps:["Allongé sur le dos, bras tendus vers le plafond, genoux à 90° en l'air", "Inspirer, puis étendre simultanément un bras et la jambe opposée", "Garder le bas du dos plaqué au sol", "Revenir et alterner"],tips:"Exercice de gainage anti-extension très efficace. La clé : maintenir le bas du dos au sol à tout moment."},
  "Bicycle crunch": {steps:["Allongé, mains derrière la nuque, jambes levées", "Ramener un genou vers la poitrine en tournant le coude opposé vers lui", "Alterner en contrôlant la rotation", "Garder les épaules décollées du sol"],tips:"Cible les obliques et le droit abdominal. L'amplitude de la rotation fait la différence."},
  "Crunch obliques": {steps:["Allongé, genoux pliés sur le côté", "Soulever les épaules en diagonale vers les genoux", "Contraction des obliques en haut", "Revenir lentement"],tips:"Isoler les obliques en gardant la rotation constante tout au long du mouvement."},
  "Shrug barre": {steps:["Debout, barre en prise pronation devant les cuisses", "Hausser les épaules le plus haut possible", "Maintenir la contraction une seconde", "Redescendre lentement"],tips:"Mouvement simple mais souvent mal exécuté. Pas de rotation des épaules, juste une élévation pure."},
  "Shrug haltères": {steps:["Debout, un haltère dans chaque main le long du corps", "Hausser les épaules le plus haut possible", "Maintenir une seconde", "Redescendre lentement"],tips:"Les haltères permettent une amplitude légèrement plus grande que la barre."},
  "Shrug câble": {steps:["Debout face à la poulie basse ou dos à elle, barre ou poignées en main", "Hausser les épaules contre la résistance constante du câble", "Maintenir une seconde en haut", "Contrôler la descente"],tips:"La tension constante du câble est particulièrement efficace pour finir le travail des trapèzes."},
  "Rowing debout upright row": {steps:["Debout, barre ou haltères devant les cuisses, prise serrée", "Tirer vers le haut en écartant les coudes vers le haut", "Monter jusqu'au menton, coudes au-dessus des mains", "Redescendre lentement"],tips:"Évite la prise trop serrée qui risque de coincer les épaules. Prise légèrement plus large."},
  "Curl poignets barre pronation": {steps:["Assis, avant-bras posés sur les cuisses, prise pronation", "Fléchir le poignet vers le haut", "Contrôler la descente", "Amplitude maximale"],tips:"Cible les extenseurs des avant-bras. Utile pour équilibrer le travail des fléchisseurs."},
  "Curl poignets barre supination": {steps:["Assis, avant-bras posés sur les cuisses, prise supination", "Fléchir le poignet vers le haut", "Amplitude maximale", "Contrôler la descente"],tips:"Cible les fléchisseurs des avant-bras. Gestes précis et contrôlés."},
  "Farmer carry": {steps:["Saisir des haltères ou kettlebells très lourds dans chaque main", "Se tenir droit, épaules en arrière et basses", "Marcher sur une distance définie en maintenant la posture", "Poser les charges avec contrôle"],tips:"Exercice fonctionnel qui renforce la prise en main, les trapèzes et le gainage global."},
  "Pronation supination haltère": {steps:["Assis ou debout, avant-bras posé sur la cuisse, haltère en main", "Faire pivoter le poignet de pronation à supination", "Mouvement lent et contrôlé", "Amplitude maximale des deux côtés"],tips:"Renforce les pronateurs et supinateurs de l'avant-bras. Utile pour prévenir les tendinites."},
  "Barre roulante wrist roller": {steps:["Debout ou assis, tenir la barre roulante à bout de bras devant soi", "Enrouler la corde en tournant les poignets alternativement", "Dérouler lentement jusqu'en bas", "Répéter"],tips:"Excellent exercice pour la force de prise et les avant-bras. Simple mais très efficace."},
  "Corde à sauter": {steps:["Tenir les poignées de la corde, corde derrière les pieds", "Sauter avec les deux pieds en faisant passer la corde", "Rester sur les pointes des pieds", "Maintenir un rythme régulier"],tips:"Excellent cardio et coordination. Commence par des sessions courtes et augmente progressivement."},
  "Burpees": {steps:["Debout, descendre en position de planche", "Faire une pompe (optionnel)", "Ramener les pieds sous soi", "Sauter en l'air bras levés en expirant"],tips:"Exercice complet qui combine force et cardio. Ajuste l'intensité en supprimant le saut ou la pompe."},
  "Mountain climbers": {steps:["Position de planche bras tendus, corps gainé", "Ramener un genou vers la poitrine rapidement", "Alterner les jambes en courant sur place", "Maintenir le gainage du torse tout au long"],tips:"Plus tu vas vite, plus l'effort cardiovasculaire est important. Garde les hanches stables."},
  "Box jump": {steps:["Debout face à la boîte, pieds à largeur d'épaules", "Fléchir les genoux et balancer les bras pour prendre de l'élan", "Sauter sur la boîte en atterrissant sur les deux pieds avec les genoux fléchis", "Descendre en contrôlant ou sauter en arrière"],tips:"Commence par une boîte basse. Atterris silencieusement pour protéger les genoux."},
  "Kettlebell swing": {steps:["Debout, kettlebell entre les jambes, pieds à largeur d'épaules", "Pousser les hanches en arrière (hip hinge)", "Propulser les hanches en avant pour lancer le kettlebell", "Laisser revenir en contrôlant la descente"],tips:"C'est un mouvement de hanche, pas un squat. La force vient des fessiers et des ischios, pas des bras."},
  "Clean and press": {steps:["Soulever la barre du sol jusqu'aux épaules (clean)", "Fléchir légèrement les genoux pour absorber", "Pousser la barre au-dessus de la tête (press)", "Redescendre aux épaules puis au sol"],tips:"Exercice technique qui combine force et puissance. Maîtrise le deadlift et le press séparément d'abord."},
  "Thruster": {steps:["Barre ou haltères aux épaules, pieds à largeur d'épaules", "Effectuer un squat complet", "En remontant, pousser la barre au-dessus de la tête en un seul mouvement fluide", "Redescendre aux épaules en début de squat suivant"],tips:"Exercice épuisant qui combine squat et développé militaire. Utilisé en CrossFit. Maintenir un rythme régulier."},
  "Battle rope": {steps:["Tenir une extrémité de la corde dans chaque main", "Genoux légèrement fléchis, dos droit", "Faire des vagues avec les bras alternativement ou simultanément", "Maintenir l'intensité sur la durée définie"],tips:"Excellent cardio et renforcement des bras, épaules et gainage. Varie les mouvements."},
  "Jumping jacks": {steps:["Debout, pieds joints, bras le long du corps", "Sauter en écartant les jambes et levant les bras au-dessus de la tête", "Sauter pour revenir en position initiale", "Maintenir un rythme régulier"],tips:"Exercice d'échauffement idéal. Atterris en douceur pour préserver les articulations."},
  "High knees": {steps:["Debout, courir sur place en montant les genoux haut", "Chaque genou doit dépasser la hauteur des hanches", "Bras actifs comme en course à pied", "Maintenir le rythme sur la durée définie"],tips:"Excellent exercice cardio. Plus tu montes les genoux, plus l'effort est intense."},
  "Burpees sans saut": {steps:["Debout, descendre en position de planche", "Faire une pompe", "Ramener les pieds sous soi", "Se relever sans sauter"],tips:"Version allégée des burpees. Idéale pour débuter ou pour les séances à faible impact articulaire."},
  // ── CARDIO / FULL BODY ────────────────────────────────────────────────────
  "Squat jump": {steps:["Debout, pieds à largeur d'épaules, orteils légèrement ouverts","Descendre en squat jusqu'à ce que les cuisses soient parallèles au sol","Exploser vers le haut en sautant le plus haut possible","Atterrir en douceur en pliant les genoux pour amortir","Enchaîner immédiatement le squat suivant"],tips:"Atterris toujours avec les genoux fléchis pour protéger les articulations. Exercice pliométrique à fort impact."},
  "Fentes sautées": {steps:["Partir en position de fente basse, genou arrière proche du sol","Sauter en l'air en changeant de jambe","Atterrir en fente avec l'autre jambe devant","Amortir la réception avec les genoux fléchis","Enchaîner en alternant"],tips:"Exercice explosif qui développe la puissance des jambes. Atterris en douceur. Non recommandé si tu as des problèmes de genoux."},
  "Montées de genoux": {steps:["Debout, course sur place","Lever alternativement les genoux à hauteur de hanches","Balancer les bras en opposition comme en course","Rester sur les avant-pieds"],tips:"Maintiens le dos droit et le regard vers l'avant. Intensifie progressivement le rythme pour augmenter la fréquence cardiaque."},
  "Talons fesses": {steps:["Debout, course sur place","Fléchir alternativement les jambes pour ramener les talons vers les fessiers","Rester sur les avant-pieds","Balancer les bras naturellement"],tips:"Travail de flexion des ischio-jambiers en dynamique. Combine avec les montées de genoux pour un échauffement complet."},
  "Sauts sur place": {steps:["Debout, pieds joints ou légèrement écartés","Fléchir légèrement les genoux","Sauter verticalement en poussant sur les deux jambes","Atterrir en souplesse en pliant les genoux pour amortir"],tips:"Simple mais efficace pour élever rapidement la fréquence cardiaque. Amorti bien les réceptions pour préserver les genoux."},
  "Sprint sur place": {steps:["Debout, légèrement penché en avant","Alterner les jambes très rapidement comme pour courir","Lever les genoux à mi-hauteur","Bouger les bras en opposition à un rythme maximal"],tips:"Effort maximal sur des intervalles courts (10-20 secondes). Récupère bien entre les séries."},
  "Corde à sauter (simulée)": {steps:["Debout, tenir des poignets imaginaires devant soi","Sauter sur place en alternant les pieds ou en les gardant joints","Faire tourner les poignets comme si on tenait une corde","Trouver un rythme régulier et maintenir"],tips:"Même sans corde, le mouvement reproduced le geste et l'effort cardio. Reste léger sur les pieds, sauts petits et rapides."},
  "Box step-up (chaise)": {steps:["Face à une chaise ou un step stable","Poser un pied entièrement sur la surface","Pousser sur ce pied pour monter, amener l'autre genou en hauteur","Redescendre lentement en contrôlant","Alterner les jambes ou compléter les reps d'un côté"],tips:"Utilise une surface stable. Garde le torse droit. Excellent exercice fonctionnel pour les quadriceps et fessiers."},
  "Snatch kettlebell": {steps:["Debout, kettlebell au sol entre les pieds","Initier avec un swing en poussant les hanches en arrière","Dans le mouvement ascendant, guider la kettlebell le long du corps","Percer le bras vers le haut pour terminer bras tendu au-dessus de la tête","Laisser descendre en contrôlant, enchaîner"],tips:"Mouvement technique à apprendre progressivement. La kettlebell doit rouler sur le poignet en haut, pas heurter l'avant-bras. Commence léger."},
  "Clean & Press kettlebell": {steps:["Kettlebell au sol, la saisir en position de swing","Amener la kettlebell en position de rack (contre l'avant-bras, coude près du corps)","Depuis le rack, pousser la kettlebell au-dessus de la tête bras tendu","Redescendre au rack puis au sol en contrôlant"],tips:"Deux mouvements enchaînés : le clean et le press. Maîtrise-les séparément avant de les combiner."},

  // ── ABDOMINAUX ────────────────────────────────────────────────────────────
  "Crunch": {steps:["Allongé sur le dos, genoux fléchis, pieds à plat","Placer les mains derrière la nuque sans tirer dessus","Contracter les abdos pour soulever les épaules du sol","Monter jusqu'à environ 30-45° et redescendre lentement"],tips:"Ne tire pas sur la nuque. L'amplitude est courte : seules les épaules quittent le sol, le bas du dos reste en contact."},
  "Crunch inversé": {steps:["Allongé sur le dos, jambes tendues à 90° vers le plafond","Placer les mains à plat sous les fessiers","Contracter les abdos inférieurs pour ramener les genoux vers la poitrine","Soulever légèrement le bassin du sol","Redescendre lentement sans laisser les pieds toucher le sol"],tips:"Mouvement subtil — le bassin se soulève à peine. Concentre-toi sur la contraction des abdos inférieurs plutôt que sur l'élan."},
  "Sit-ups": {steps:["Allongé sur le dos, genoux fléchis, pieds à plat ou tenus","Bras croisés sur la poitrine ou derrière la tête","Monter jusqu'à la position assise en contractant les abdos","Redescendre lentement en contrôlant"],tips:"Exercice complet sollicitant tout le droit abdominal et le psoas. Va jusqu'en bas lentement pour maximiser l'amplitude."},
  "Relevé de jambes": {steps:["Allongé sur le dos, mains sous les fessiers ou à côté","Jambes tendues ou légèrement fléchies","Lever les jambes jusqu'à 90° en contractant les abdos inférieurs","Redescendre lentement sans toucher le sol"],tips:"Ne laisse pas le bas du dos se creuser pendant la descente. Si c'est le cas, garde les jambes un peu plus fléchies."},
  "Planche": {steps:["Position sur les avant-bras et les orteils","Corps en ligne droite de la tête aux talons","Contracter les abdos, les fessiers et les quadriceps","Maintenir la position sans laisser les hanches monter ou descendre"],tips:"La planche est un exercice isométrique. Respire normalement. Augmente progressivement la durée. Évite de regarder en bas."},
  "Planche latérale": {steps:["Sur un avant-bras et le côté des pieds (ou genoux pour faciliter)","Corps en ligne droite de la tête aux pieds","Lever la hanche vers le plafond","Maintenir la position en contractant le côté","Effectuer le même temps de chaque côté"],tips:"Travaille les obliques et les stabilisateurs. Garde la hanche haute, ne la laisse pas affaisser."},
  "Planche superman": {steps:["En position de planche sur les avant-bras","Lever alternativement un bras en avant tout en levant la jambe opposée","Maintenir 2-3 secondes en équilibre","Reposer et alterner de l'autre côté","Garder les hanches stables pendant le mouvement"],tips:"Excellent pour la coordination et les muscles stabilisateurs du dos. Va lentement pour maximiser le temps sous tension."},
  "Planche dynamique": {steps:["Commencer en position de planche sur les avant-bras","Pousser sur une main pour monter en appui bras tendu","Pousser sur l'autre main pour être en position de pompe","Redescendre sur un avant-bras puis l'autre","Alterner le bras qui mène"],tips:"Combine gainage et force des bras. Minimise les rotations du bassin en contractant bien les abdos tout au long."},
  "Russian Twist kettlebell": {steps:["Assis au sol, genoux fléchis, pieds légèrement décollés","Tenir la kettlebell à deux mains devant soi","S'incliner légèrement en arrière pour créer un angle de 45°","Tourner le torse d'un côté en amenant la kettlebell","Revenir au centre et tourner de l'autre côté"],tips:"Garde le dos droit, ne te penche pas trop en arrière. La rotation vient du torse, pas des bras."},
  "Ab wheel": {steps:["À genoux sur le sol, tenir la roue abdominale à deux mains","Contracter les abdos et commencer à faire rouler la roue en avant","Avancer jusqu'à être presque allongé en gardant le corps tendu","Contracter les abdos pour revenir à la position de départ","Ne pas laisser le dos se creuser"],tips:"Exercice très exigeant. Commence par de courtes amplitudes. Une des meilleures options pour les abdos profonds et la sangle abdominale."},
  "Toes to bar": {steps:["Suspendu à une barre, prise légèrement plus large que les épaules","Balancer légèrement pour initier le mouvement","Lever les jambes tendues jusqu'à toucher la barre avec les orteils","Redescendre de façon contrôlée","Éviter les balancements excessifs"],tips:"Exercice avancé demandant force abdominale et souplesse. Commence par des relevés de genoux si nécessaire."},
  "Abdominaux portefeuille": {steps:["Allongé sur le dos, bras tendus derrière la tête, jambes tendues","Simultanément lever les bras et les jambes pour se retrouver en V","Les mains vont vers les pieds","Redescendre lentement les deux membres en même temps","Ne pas poser complètement avant de relancer"],tips:"Travaille simultanément les abdos supérieurs et inférieurs. Garde les mouvements contrôlés."},
  "Abdominaux coude genou croisés": {steps:["Allongé sur le dos, mains derrière la tête, genoux fléchis","Lever les épaules du sol comme pour un crunch","Amener le coude droit vers le genou gauche tout en tendant la jambe droite","Alterner de l'autre côté dans un mouvement de pédalage","Garder le rythme régulier"],tips:"Travaille les obliques et les abdos croisés. Ne tire pas sur la nuque, l'épaule tout entière se tourne vers le genou."},
  "Scissors (ciseaux)": {steps:["Allongé sur le dos, mains sous les fessiers","Lever les deux jambes à environ 30-45 cm du sol","Croiser les jambes alternativement en ciseaux horizontaux","Garder les jambes tendues et le bas du dos au sol"],tips:"Maintiens la tension abdominale permanente. Si le bas du dos se décolle, lève les jambes un peu plus haut."},
  "Touche talons": {steps:["Allongé sur le dos, genoux fléchis, pieds à plat sur le sol","Épaules légèrement décollées du sol","Latéraliser le torse pour toucher le talon droit avec la main droite","Alterner de l'autre côté en restant décollé du sol"],tips:"Cible les obliques. Mouvement court et précis, ne te contente pas d'incliner les épaules — toute la cage thoracique se latéralise."},
  "Chandelle": {steps:["Allongé sur le dos","Lever les jambes tendues à 90° puis soulever le bassin","Se soutenir avec les mains dans le bas du dos","Corps vertical, poids sur les épaules et les bras","Tenir la position ou descendre lentement"],tips:"Renforce les abdos inférieurs et améliore l'équilibre. Ne mets jamais le poids sur le cou. Décompresse lentement."},
  "Pallof Press": {steps:["Debout ou à genoux, de côté par rapport à l'attache d'un élastique ou poulie","Tenir les deux mains à la poitrine face à l'attache","Pousser les bras en avant en résistant à la rotation","Tenir 1-2 secondes bras tendus","Ramener les mains à la poitrine lentement"],tips:"Anti-rotation pure : les abdos résistent à la torsion. Plus tu t'éloignes du point d'attache, plus c'est difficile."},
  "Superman": {steps:["Allongé face contre terre, bras tendus devant, jambes tendues","Simultanément lever le bras droit et la jambe gauche","Maintenir 2-3 secondes en contractant les lombaires et fessiers","Redescendre et alterner","Ou lever les deux bras et les deux jambes ensemble"],tips:"Renforce les lombaires, les fessiers et les muscles du dos profond. Essentiel pour équilibrer le travail abdominal."},

  // ── QUADRICEPS / JAMBES ───────────────────────────────────────────────────
  "Squats": {steps:["Debout, pieds à largeur d'épaules, orteils légèrement ouverts","Pousser les hanches en arrière et fléchir les genoux","Descendre jusqu'à ce que les cuisses soient parallèles au sol (ou plus bas)","Genoux dans l'axe des orteils, ne pas les laisser tomber vers l'intérieur","Pousser sur les talons pour remonter"],tips:"Le squat est le roi des exercices. Dos neutre, regard droit devant. La profondeur vient avec la mobilité."},
  "Squat barre": {steps:["Barre posée sur les trapèzes (squat haute barre) ou les deltoïdes postérieurs (basse barre)","Pieds à largeur d'épaules, orteils légèrement ouverts","Déverrouiller les hanches et les genoux simultanément pour descendre","Descendre jusqu'à ce que les cuisses soient parallèles ou en dessous","Remonter en poussant le sol avec les pieds"],tips:"Maîtrise la technique avant d'augmenter les charges. Utilise toujours un rack avec des jambages de sécurité réglés, et des colliers de serrage. Un partenaire pour les séries lourdes est un plus."},
  "Squat avant": {steps:["Barre posée sur les deltoïdes antérieurs, coudes hauts en avant","Pieds légèrement plus larges que les épaules","Descendre en gardant le torse très vertical (plus que le squat dos)","Cuisses parallèles ou en dessous","Pousser sur les talons pour remonter"],tips:"Plus technique que le squat dos. Cible davantage les quadriceps. Nécessite une bonne mobilité des poignets et une flexibilité des chevilles."},
  "Squat goblet": {steps:["Tenir un haltère ou une kettlebell à deux mains contre la poitrine","Pieds légèrement plus larges que les épaules, orteils ouverts","Descendre en squat profond en gardant les coudes entre les genoux","Le poids aide à garder le torse vertical","Remonter en poussant sur toute la plante des pieds"],tips:"Excellent pour apprendre le squat profond. Le contrepoids du goblet facilite la verticalité du torse et l'ouverture des genoux."},
  "Squat isométrique mur": {steps:["Dos contre un mur, pieds à 60-90 cm du mur","Descendre en squat jusqu'à ce que les cuisses soient parallèles au sol","Genoux à 90°, dos plaqué contre le mur","Maintenir la position le temps prescrit","Respirer normalement pendant l'effort"],tips:"Exercice isométrique intense pour les quadriceps. Augmente progressivement la durée. Douleur brûlante = normal ; douleur articulaire = arrêter."},
  "Squat pulse": {steps:["Descendre en squat bas et maintenir la position basse","Effectuer de petites pulsations vers le bas (3-5 cm d'amplitude)","Rester en permanence dans le bas du squat","Garder la contraction musculaire constante"],tips:"Le travail en contraction continue brûle intensément les quadriceps. Ne remonte jamais complètement pendant les pulsations."},
  "Squat avec bande": {steps:["Élastique autour des genoux ou des cuisses","Position de squat classique","La bande résiste à l'écartement des genoux — pousser activement contre la bande","Descendre et remonter en maintenant les genoux vers l'extérieur"],tips:"L'élastique active les fessiers (moyen et grand) et améliore le patron moteur du squat. Idéal pour ceux qui ont tendance à avoir les genoux qui rentrent."},
  "Goblet Squat kettlebell": {steps:["Tenir la kettlebell à deux mains par les cornes contre la poitrine","Pieds légèrement plus larges que les épaules","Descendre profondément en squat en gardant les coudes entre les genoux","Le poids de la kettlebell aide à ouvrir les hanches","Remonter en poussant sur les talons"],tips:"Identique au squat goblet. La kettlebell, par sa forme, facilite la prise en goblet."},
  "Fentes avant": {steps:["Debout, pieds joints","Faire un grand pas en avant avec une jambe","Descendre jusqu'à ce que le genou arrière effleure le sol","Genou avant dans l'axe du pied, ne pas dépasser l'orteil","Pousser sur le pied avant pour revenir en position initiale"],tips:"Garde le torse droit et le regard devant. Le genou arrière descend vers le sol sans le frapper."},
  "Fentes alternées": {steps:["Debout, alterner les fentes avant gauche et droite","Faire un pas, descendre, remonter et revenir avant d'alterner","Ou effectuer toutes les répétitions d'un côté puis de l'autre"],tips:"Excellent exercice unilatéral pour équilibrer les jambes. Attention à la stabilité du genou avant."},
  "Fentes haltères": {steps:["Tenir un haltère dans chaque main","Effectuer des fentes avant ou marchées","Bras tendus le long du corps pendant le mouvement","Alterner les jambes"],tips:"Le poids ajoute de la résistance. Garde les haltères stables, ne les balance pas pendant le mouvement."},
  "Fentes bulgares": {steps:["Pied arrière posé sur un banc ou une chaise","Pied avant à environ un mètre devant","Descendre en fléchissant le genou avant jusqu'à ce que la cuisse soit parallèle","Genou arrière proche du sol","Pousser sur le pied avant pour remonter"],tips:"Exercice unilatéral exigeant. Commence sans poids pour maîtriser l'équilibre. Excellent pour cibler les quadriceps et fessiers indépendamment."},
  "Fentes marchées haltères": {steps:["Tenir des haltères dans chaque main","Avancer en fente sur la jambe droite","Sans revenir, avancer directement en fente sur la jambe gauche","Continuer à avancer en alternant les jambes","Maintenir le torse droit tout au long"],tips:"Combine cardio et renforcement musculaire. Nécessite de l'espace. Garde un rythme régulier et des foulées de longueur constante."},
  "Fentes marchées kettlebell": {steps:["Tenir une kettlebell dans chaque main (ou une tenue à deux mains pour débuter)","Avancer en fente sur la jambe droite, genou arrière proche du sol","Sans revenir en position initiale, avancer directement en fente sur la jambe gauche","Continuer à avancer en alternant les jambes","Torse droit, regard devant, haltères stables le long du corps"],tips:"Le centre de gravité décalé de la kettlebell sollicite davantage les stabilisateurs que les haltères. Commence avec une seule kettlebell tenue à deux mains pour maîtriser l'équilibre."},
  "Fentes barre": {steps:["Barre sur les trapèzes comme pour le squat dos","Faire un grand pas en avant","Descendre jusqu'à ce que le genou arrière effleure le sol","Pousser pour revenir et alterner","Ou effectuer toutes les reps d'une jambe puis de l'autre"],tips:"Exercice avancé. La barre amplifie les contraintes sur le genou — maîtrise les fentes sans barre avant."},
  "Fentes élastique": {steps:["Élastique sous le pied avant, tenu dans les mains ou sur les épaules","Effectuer la fente classique","La résistance de l'élastique augmente à mesure qu'on monte","Alterner les jambes"],tips:"Résistance progressive adaptée au domicile. Règle la longueur de l'élastique pour ajuster la difficulté."},
  "Step-up sur chaise": {steps:["Face à une chaise robuste ou un step stable","Poser un pied entièrement sur la surface","Monter en poussant sur ce pied, amener l'autre genou en hauteur","Redescendre lentement","Alterner les jambes ou compléter les reps d'un côté"],tips:"Utilise uniquement des surfaces stables. Pousse principalement avec la jambe sur la chaise, pas avec la jambe basse."},

  // ── FESSIERS / ISCHIO ─────────────────────────────────────────────────────
  "Hip thrust": {steps:["Épaules appuyées sur un banc, pieds à plat sur le sol, une barre sur les hanches","Descendre les hanches vers le sol","Pousser les hanches vers le haut en contractant les fessiers","Atteindre l'extension complète — corps en ligne droite des épaules aux genoux","Redescendre lentement"],tips:"Le mouvement roi pour les fessiers. Au point haut, contracte au maximum. Utilise un pad ou une serviette pour protéger les hanches de la barre."},
  "Hip thrust au sol": {steps:["Allongé sur le dos, genoux fléchis, pieds à plat","Bras le long du corps pour s'appuyer","Pousser les hanches vers le haut en contractant les fessiers","Atteindre l'extension complète","Redescendre sans toucher le sol et relancer"],tips:"Version sans banc du hip thrust. Moins d'amplitude qu'avec le banc mais très efficace. Peut se faire avec un poids sur les hanches."},
  "Hip Thrust avec bande": {steps:["Même position que le hip thrust au sol","Élastique positionné sur les hanches ou les cuisses","Pousser les hanches vers le haut contre la résistance de la bande","Maintenir la contraction en haut 1-2 secondes"],tips:"La bande élastique ajoute une résistance progressive. Idéal à domicile pour simuler la résistance de la barre."},
  "Glute bridge unilatéral": {steps:["Allongé sur le dos, un pied à plat sur le sol, l'autre jambe tendue ou fléchie en l'air","Pousser sur le talon au sol pour lever les hanches","S'assurer que les hanches restent au même niveau","Maintenir l'extension 1-2 secondes","Effectuer toutes les reps d'un côté puis de l'autre"],tips:"Version unilatérale plus intense. Renforce chaque fessier indépendamment pour corriger les déséquilibres."},
  "Pont fessier": {steps:["Allongé sur le dos, genoux fléchis, pieds à plat à largeur de hanches","Presser les pieds au sol pour soulever les hanches","Contracter les fessiers au sommet","Corps en ligne droite épaules-hanches-genoux","Redescendre lentement"],tips:"Version accessible du hip thrust sans équipement. Excellent exercice d'activation des fessiers. Peut être rendu plus difficile avec une jambe tendue."},
  "Donkey kicks": {steps:["À quatre pattes, mains sous les épaules, genoux sous les hanches","Garder le genou fléchi à 90°","Lever la jambe vers le plafond en poussant avec le talon","Contracter le fessier au sommet","Redescendre sans toucher le sol","Compléter les reps d'un côté puis de l'autre"],tips:"Mouvement d'isolation des fessiers. Garde le dos plat et les abdos contractés — ne laisse pas le dos se creuser quand tu lèves la jambe."},
  "Kickback debout": {steps:["Debout, tenir un support pour l'équilibre si nécessaire","Tendre une jambe en arrière en contractant le fessier","Monter la jambe le plus haut possible sans incliner le buste","Maintenir 1 seconde en haut","Redescendre et enchaîner ou alterner"],tips:"Peut être fait avec un élastique autour des chevilles pour augmenter la résistance. Garde le torse droit."},
  "Monster Walk": {steps:["Élastique autour des chevilles ou des genoux","Légèrement fléchi en squat","Avancer en effectuant de grands pas latéraux","Maintenir la tension de l'élastique en permanence (pieds jamais joints)","Reculer de la même façon pour revenir"],tips:"Exercice d'activation des fessiers (moyen) et des abducteurs. Essentiel pour la stabilité du genou. Garde les pieds parallèles ou légèrement ouverts."},
  "Nordic curl": {steps:["À genoux sur une surface rembourrée, chevilles bloquées sous un support lourd ou par un partenaire","Corps droit des genoux à la tête","Descendre lentement vers l'avant en résistant avec les ischio-jambiers","Aller le plus bas possible avant de se rattraper avec les mains","Remonter en poussant avec les mains et en contractant les ischio"],tips:"Un des exercices les plus difficiles pour les ischio-jambiers. Commence avec de petites amplitudes. Excellent pour prévenir les blessures musculaires."},
  "Soulevé de terre kettlebell": {steps:["Kettlebell entre les pieds, pieds à largeur d'épaules","Saisir la poignée, dos plat, hanches en arrière","Pousser le sol pour se redresser en gardant la kettlebell proche du corps","Extension complète des hanches et des genoux en haut","Redescendre en contrôlant, hanches en arrière en premier"],tips:"Même mécanique que le soulevé de terre classique. La kettlebell permet de travailler avec une seule main pour varier."},

  // ── DOS ───────────────────────────────────────────────────────────────────
  "Rowing haltères": {steps:["Buste penché à environ 45°, haltère dans une main, l'autre appuyée sur le genou ou un banc","Laisser l'haltère pendre bras tendu","Tirer l'haltère vers la hanche en ramenant le coude vers l'arrière","Contracter l'omoplate en haut","Redescendre lentement en gardant le contrôle"],tips:"Exercice de rowing unilatéral basique. Garde le dos plat tout au long. Le coude longe le corps et passe derrière le plan du dos."},
  "Rowing buste penché haltères": {steps:["Debout, haltères dans les deux mains","Se pencher à environ 45° en gardant le dos plat","Laisser les haltères pendre bras tendus","Tirer les deux haltères simultanément vers les hanches","Contracter les omoplates en haut et redescendre lentement"],tips:"Version bilatérale du rowing haltères. Attention à maintenir le dos neutre — ne pas arrondir le bas du dos sous la charge."},
  "Rowing barre": {steps:["Debout, barre en mains prise pronation","Se pencher à environ 45°, dos plat, genoux légèrement fléchis","Tirer la barre vers le nombril en ramenant les coudes vers l'arrière","Serrer les omoplates en haut","Redescendre en contrôlant"],tips:"Exercice fondamental pour le dos épais. Garde la barre proche du corps. Le dos ne doit pas s'arrondir, en aucun cas."},
  "Rowing bûcheron": {steps:["Un pied en avant, main du même côté appuyée sur le genou fléchi","Haltère dans l'autre main, bras tendu","Tirer l'haltère vers la hanche en montant le coude haut","Rotation légère du torse autorisée","Redescendre lentement"],tips:"La rotation partielle du torse permet une plus grande amplitude et engage davantage les rhomboïdes. Reste en contrôle."},
  "Rowing inversé": {steps:["Allongé sous une table basse ou une barre fixée bas","Saisir la surface les mains à largeur d'épaules","Corps tendu comme une planche inversée, talons au sol","Tirer le corps vers le haut en ramenant la poitrine vers la barre/table","Descendre lentement"],tips:"Aussi appelé 'Australian pull-up'. Excellente introduction aux tractions. Plus la barre est basse, plus c'est difficile."},
  "Tractions australiennes": {steps:["S'allonger sous une barre basse (hauteur de hanche environ) ou des anneaux","Saisir la barre en prise pronation à largeur d'épaules","Tendre le corps en ligne droite des talons à la tête, talons au sol","Tirer la poitrine vers la barre en ramenant les coudes en arrière","Contracter les omoplates en haut","Redescendre lentement jusqu'à l'extension complète des bras"],tips:"Plus la barre est basse, plus c'est difficile. Idéal pour progresser vers les tractions. Garde le corps rigide — pas de hanches qui tombent."},
  "Tractions pronation": {steps:["Saisir la barre prise pronation (paumes vers l'avant) à largeur d'épaules ou plus large","Partir bras tendus, déprimer les omoplates","Tirer le menton au-dessus de la barre en ramenant les coudes vers le bas","Maintenir une seconde en haut","Redescendre lentement jusqu'à l'extension complète"],tips:"Identique aux tractions pronation large. Prise standard = dos large sollicité. Prise large = encore plus de grand dorsal."},
  "Tractions supination": {steps:["Saisir la barre prise supination (paumes vers soi) à largeur d'épaules","Partir bras tendus","Tirer le menton au-dessus de la barre en gardant les coudes près du corps","Descendre lentement"],tips:"Plus facile que la prise pronation grâce à la contribution des biceps. Excellent pour débuter les tractions."},
  "Rowing unilatéral kettlebell": {steps:["Un genou et une main sur le banc, ou debout légèrement penché, dos plat","Kettlebell dans la main libre, bras tendu vers le sol","Tirer la kettlebell vers la hanche en ramenant le coude vers l'arrière et le haut","La poignée permet une rotation naturelle du poignet — profites-en pour une amplitude plus grande","Contracter l'omoplate en fin de mouvement","Redescendre lentement jusqu'à l'extension complète"],tips:"Plus d'amplitude qu'avec un haltère grâce à la rotation du poignet. Garde le dos plat — ne fais pas tourner le torse pour compenser."},
  "Tirage horizontal élastique": {steps:["Élastique attaché à hauteur du sternum","Saisir les deux extrémités","Se mettre en position de rowing debout ou assis","Tirer les mains vers le buste en ramenant les coudes en arrière","Contracter les omoplates et relâcher lentement"],tips:"Simule le rowing câble assis. La résistance augmente avec l'étirement. Garde les épaules basses pendant tout le mouvement."},
  "Tirage vertical élastique": {steps:["Élastique fixé en hauteur","Saisir les extrémités, bras tendus au-dessus","Tirer vers le bas ou vers la nuque en ramenant les coudes","Contracter le grand dorsal en bas du mouvement","Relâcher lentement"],tips:"Simule le tirage vertical machine ou poulie haute. Idéal pour cibler le grand dorsal à domicile."},

  // ── ÉPAULES ───────────────────────────────────────────────────────────────
  "Oiseau haltères": {steps:["Buste penché en avant à environ 45-90°","Haltères dans les deux mains, paumes se faisant face, bras légèrement fléchis","Lever les bras sur les côtés jusqu'à la hauteur des épaules","Contracter les deltoïdes postérieurs et les rhomboïdes","Redescendre lentement"],tips:"Cible les deltoïdes postérieurs souvent négligés. Ne balaie pas avec les bras, le mouvement est contrôlé. Charge légère et amplitude complète."},
  "Face Pull élastique": {steps:["Élastique fixé à hauteur de visage","Saisir les extrémités, paumes vers le bas","Tirer l'élastique vers le visage en écartant les mains","Les coudes partent sur les côtés et passent derrière le plan du corps","Maintenir 1 seconde et relâcher"],tips:"Excellent pour les deltoïdes postérieurs et les rotateurs externes. Mouvement à faire régulièrement pour contre-balancer les exercices de poussée."},
  "Développé épaules unilatéral kettlebell": {steps:["Assis ou debout, kettlebell en position de rack (sur l'avant-bras)","Pousser la kettlebell vers le haut en tendant le bras","Garder le core gainé pour éviter l'inclinaison latérale","Redescendre en contrôlant jusqu'au rack","Effectuer toutes les reps d'un côté puis de l'autre"],tips:"Le centre de gravité décalé de la kettlebell défie la stabilité. Core très actif pour rester droit."},
  "Turkish Get-Up": {steps:["Allongé sur le dos, kettlebell tenue bras tendu au-dessus de l'épaule","Monter en appui sur le coude du même côté, jambe du même côté fléchie","Pousser sur la main pour s'asseoir","Lever le bassin en appui sur le pied et la main","Passer la jambe tendue sous le corps pour se mettre à genoux","Se lever debout — puis inverser exactement chaque étape pour revenir au sol"],tips:"Mouvement complet par excellence : mobilité, force, stabilité. Commence avec une charge légère et maîtrise chaque phase séparément."},
  "Élévations latérales élastique": {steps:["Élastique sous les pieds ou fixé à hauteur basse","Tenir les extrémités dans chaque main","Lever les bras sur les côtés jusqu'à la hauteur des épaules","Paumes vers le bas ou légèrement vers l'avant","Redescendre lentement en contrôlant la résistance"],tips:"Simule les élévations latérales haltères. La résistance de l'élastique est progressive. Maintiens les coudes légèrement fléchis."},

  // ── BICEPS ────────────────────────────────────────────────────────────────
  "Curl haltères": {steps:["Debout ou assis, haltère dans chaque main bras tendus","Fléchir les avant-bras en amenant les haltères vers les épaules","Supination des poignets (paumes vers le haut) pendant la montée","Contracter les biceps en haut","Redescendre lentement en contrôlant"],tips:"Le curl basique le plus complet. Évite de balancer le corps — seuls les avant-bras bougent."},
  "Curl haltères alternés": {steps:["Debout ou assis, haltère dans chaque main","Alterner les bras : lever l'un pendant que l'autre descend","Supination pendant la montée","Contrôler la descente de chaque bras"],tips:"Permet de se concentrer sur chaque bras tour à tour. Favorise une meilleure connexion neuromusculaire."},
  "Curl biceps élastique": {steps:["Élastique sous les pieds, tenir les extrémités dans les mains","Bras le long du corps, paumes vers l'avant","Fléchir les avant-bras en remontant les mains vers les épaules","Contracter les biceps en haut","Redescendre lentement"],tips:"Résistance progressive idéale à domicile. Plus tu tires, plus la résistance augmente — différent des haltères."},
  "Curl isométrique": {steps:["Haltère ou objet dans une main, avant-bras à 90°","Maintenir la position sans bouger pendant la durée prescrite","Respirer normalement","Effectuer les deux côtés"],tips:"Travail en isométrie qui maintient une tension constante sur le biceps. Très efficace pour les points faibles dans la course du mouvement."},
  "Curl concentré": {steps:["Assis sur un banc, coude appuyé contre la face interne de la cuisse","Haltère dans la main, bras tendu","Fléchir lentement l'avant-bras vers l'épaule","Contracter au maximum en haut","Redescendre lentement"],tips:"L'appui sur la cuisse fixe le bras et isole complètement le biceps. Charge plus légère que le curl debout."},
  "Curl barre": {steps:["Debout, barre en mains prise supination à largeur d'épaules","Bras tendus, barre contre les cuisses","Fléchir les avant-bras pour amener la barre vers les épaules","Contracter les biceps en haut","Redescendre lentement en résistant au poids"],tips:"La barre permet de charger plus lourd. Ne bascule pas le buste en arrière pour soulever — si c'est le cas, réduis le poids."},

  // ── TRICEPS ───────────────────────────────────────────────────────────────
  "Dips sur banc": {steps:["Mains posées sur un banc derrière soi, pieds devant à plat sur le sol","Descendre en fléchissant les coudes jusqu'à environ 90°","Coudes dans l'axe du corps, pas trop écartés","Pousser pour remonter jusqu'à l'extension","Garder les hanches proches du banc"],tips:"Exercice accessible pour débuter les dips. Genoux fléchis = plus facile, jambes tendues = plus difficile."},
  "Dips sur chaise": {steps:["Mains sur une chaise solide derrière soi","Même mouvement que les dips sur banc","S'assurer que la chaise ne glisse pas"],tips:"Version domestique des dips sur banc. Utilise deux chaises stables si possible pour plus de sécurité."},
  "Dips": {steps:["Mains sur deux barres parallèles, bras tendus","Se pencher légèrement en avant pour cibler davantage les triceps (droit = plus triceps)","Descendre en fléchissant les coudes jusqu'à 90°","Remonter jusqu'à l'extension complète sans verrouiller"],tips:"Exercice de force compound pour les triceps et la poitrine. Commence sans lest et progresse progressivement."},
  "Kickback haltères": {steps:["Buste penché, bras upper-arm parallèle au sol","Haltère dans la main, avant-bras perpendiculaire au sol","Étendre l'avant-bras vers l'arrière jusqu'à l'extension complète","Contracter le triceps en fin de mouvement","Redescendre lentement"],tips:"Exercice d'isolation du triceps. Le coude reste fixe et haut — seul l'avant-bras bouge."},
  "Barre au front": {steps:["Allongé sur un banc, barre ou EZ-bar tenue bras tendus au-dessus de la poitrine","Fléchir les coudes en abaissant la barre vers le front ou derrière la tête","Les coudes ne bougent pas — seuls les avant-bras descendent","Remonter jusqu'à l'extension complète"],tips:"Aussi appelé Skull crusher. Exercice efficace pour les trois chefs des triceps. Attention aux épaules — garde les coudes dans l'axe."},
  "Extension triceps élastique": {steps:["Élastique fixé en hauteur ou tenu dans le dos","Saisir l'extrémité, coude plié derrière la tête","Étendre le bras vers le haut ou vers le bas selon la position de l'élastique","Contracter le triceps en fin de mouvement","Revenir lentement"],tips:"Simule l'extension nuque ou le pushdown. Garde le coude fixe pendant tout le mouvement."},

  // ── PECTORAUX SUPPLÉMENTAIRES ─────────────────────────────────────────────
  "Pompes classiques": {steps:["Position de planche, mains légèrement plus larges que les épaules","Corps gainé, tête dans l'axe de la colonne","Descendre la poitrine vers le sol en fléchissant les coudes à 45°","Pousser jusqu'à l'extension sans verrouiller les coudes"],tips:"La base de tous les exercices au poids du corps. Qualité de mouvement primordiale sur la quantité."},
  "Pompes larges": {steps:["Mains plus larges que dans les pompes classiques","Corps gainé","Descendre en fléchissant les coudes","Pousser jusqu'à l'extension"],tips:"Prise large = plus de pectoraux, moins de triceps. Garde les coudes à 45-75° du corps."},
  "Pompes sur genoux": {steps:["Position de planche modifiée : genoux au sol","Mains à largeur d'épaules","Descendre la poitrine vers le sol","Pousser jusqu'à l'extension"],tips:"Version accessible pour les débutants. Idéal pour apprendre la mécanique avant de passer aux pompes complètes."},
  "Pompes Spiderman": {steps:["Position de pompe classique","Lors de la descente, ramener le genou droit vers le coude droit","Remonter et alterner de l'autre côté","Corps gainé tout au long"],tips:"Combine pompes et mobilité de hanches. Travaille les pectoraux, triceps et les fléchisseurs de hanche."},
  "Pompes claquées": {steps:["Position de pompe","Descendre normalement","Dans la poussée, accélérer pour décoller les mains du sol","Taper les mains ensemble si possible","Réceptionner en souplesse avec les coudes fléchis"],tips:"Exercice pliométrique avancé pour développer la puissance des pectoraux. Ne pas faire si vous avez des problèmes aux poignets."},
  "Développé poitrine élastique": {steps:["Élastique passé dans le dos à hauteur des omoplates","Tenir les extrémités dans les mains","Pousser les mains en avant (position debout) ou vers le plafond (allongé)","Résister à la tension lors du retour"],tips:"Simule le développé couché. L'effort maximal est en fin de mouvement contrairement aux haltères. Idéal en combinaison avec les pompes."},
  "Écarté haltères": {steps:["Allongé sur le sol ou un banc","Haltères en haut bras quasi tendus","Ouvrir les bras en arc large en inspirant, coudes légèrement fléchis","Descendre jusqu'à sentir l'étirement des pectoraux","Refermer en expirant"],tips:"Cible l'étirement des pectoraux. Au sol, l'amplitude est limitée — sur banc, l'amplitude est complète."},

  // ── TRAPÈZES / AVANT-BRAS ─────────────────────────────────────────────────
  "Farmer Walk kettlebell": {steps:["Tenir une kettlebell dans chaque main","Se tenir droit, épaules en arrière et en bas","Marcher à un rythme normal sur une distance définie","Garder le core gainé pour ne pas s'incliner","Reposer et répéter"],tips:"Exercice fonctionnel complet : trapèzes, avant-bras, core, jambes. La difficulté réside dans le maintien de la posture sous charge. Commence avec une seule kettlebell."},
  "Farmer walk": {steps:["Tenir une charge lourde dans chaque main","Se tenir droit et marcher","Garder les épaules en arrière et en bas","Core gainé tout au long"],tips:"Version générique du farmer walk. Peut être fait avec des haltères, des kettlebells, des sacs lestés ou tout objet lourd."},
  "Mollets debout": {steps:["Debout, pieds à largeur de hanches","Se lever sur les pointes des pieds en contractant les mollets","Maintenir 1 seconde au sommet","Redescendre lentement en laissant le talon descendre sous le niveau du sol si possible (marche ou step)"],tips:"Plus l'amplitude est grande, plus les mollets sont sollicités. Peut être fait avec une charge dans les mains."},
  "Mollets sur marche": {steps:["Avant des pieds sur une marche ou un step, talons dans le vide","Descendre les talons sous le niveau de la marche pour étirer les mollets","Monter le plus haut possible sur les pointes","Maintenir 1 seconde en haut","Descendre lentement"],tips:"L'amplitude complète (étirement + contraction) maximise le développement des mollets. Tiens-toi à un mur pour l'équilibre."},

  // ── EXERCICES ÉLASTIQUE ───────────────────────────────────────────────────
  "Rowing debout élastique": {steps:["Élastique fixé à hauteur de taille ou légèrement plus bas","Saisir les deux extrémités, reculer pour créer de la tension","Se pencher légèrement en avant, dos plat","Tirer les mains vers les hanches en ramenant les coudes en arrière","Serrer les omoplates en fin de mouvement","Relâcher lentement en tendant les bras"],tips:"Simule le rowing barre. Plus tu recules du point d'attache, plus la résistance est élevée. Garde le dos neutre et les épaules basses."},
  "Traction assistée élastique": {steps:["Passer l'élastique autour de la barre de traction","Mettre un genou ou les deux pieds dans la boucle","Saisir la barre prise pronation à largeur d'épaules","L'élastique aide au moment le plus difficile (démarrage)","Tirer jusqu'à ce que le menton passe la barre","Redescendre lentement"],tips:"Idéal pour progresser vers les tractions sans aide. Utilise un élastique plus léger au fil des semaines pour diminuer l'assistance."},
  "Rowing unilatéral élastique": {steps:["Élastique fixé à hauteur basse","Saisir une extrémité dans une main, pieds à largeur d'épaules","Buste légèrement penché, bras tendu","Tirer le coude vers l'arrière en ramenant la main vers la hanche","Rétracter l'omoplate en fin de mouvement","Effectuer toutes les reps d'un côté puis de l'autre"],tips:"Permet de travailler chaque côté du dos indépendamment. Maintiens le torse stable, ne te tords pas pour compenser."},
  "Overhead press élastique": {steps:["Élastique sous les deux pieds, tenir les extrémités à hauteur d'épaules, paumes vers l'avant","Pousser les mains au-dessus de la tête jusqu'à l'extension complète","Légèrement incliner les coudes vers l'avant en montant","Redescendre lentement jusqu'à hauteur d'épaules","Garder le core gainé pour ne pas creuser le bas du dos"],tips:"Simule le développé militaire haltères. La résistance augmente avec la montée — le point le plus difficile est en fin de mouvement."},
  "Pec fly élastique": {steps:["Élastique fixé en hauteur (barre, porte) de chaque côté ou tenu dans le dos","Tendre les deux bras en croix, légèrement fléchis","Ramener les mains devant la poitrine comme pour une embrassade","Contracter les pectoraux en fin de mouvement","Ouvrir les bras lentement en résistant à la tension"],tips:"Simule l'écarté poulie ou pec deck. Maintiens les coudes légèrement fléchis tout au long — ne les verrouille jamais. L'étirement en position ouverte est très efficace."},
  "Kickback triceps élastique": {steps:["Élastique fixé ou tenu sous le pied avant en position fléchie","Buste penché, coude de travail levé et fixe à hauteur des épaules","Avant-bras pendant vers le bas","Étendre l'avant-bras vers l'arrière jusqu'à l'extension complète","Contracter le triceps en fin de mouvement","Revenir lentement"],tips:"Isolation du triceps. Le coude reste parfaitement immobile — c'est la clé de l'exercice. Résistance progressive idéale."},
  "Good morning élastique": {steps:["Élastique sous les pieds, tenir les extrémités sur les épaules","Pieds à largeur d'épaules, légère flexion des genoux","Incliner le buste en avant en poussant les hanches en arrière","Dos neutre, regard vers le sol légèrement en avant","Descendre jusqu'à sentir l'étirement des ischio-jambiers","Remonter en contractant les fessiers et les lombaires"],tips:"Renforce les ischio-jambiers, fessiers et lombaires. Ne descends pas au-delà de ta mobilité — le dos doit rester plat en permanence."},
  "Squat sumo élastique": {steps:["Élastique sous les pieds, saisir les extrémités à deux mains","Pieds très écartés (plus large que les épaules), orteils très ouverts","Descendre en squat en gardant le torse droit","Genoux dans l'axe des orteils, pousser les genoux vers l'extérieur","Remonter en contractant les fessiers et les adducteurs"],tips:"Cible davantage les adducteurs et les fessiers que le squat classique. L'écartement des pieds s'adapte à ta morphologie."},
  "Leg abduction élastique": {steps:["Élastique autour des chevilles ou juste au-dessus des genoux","Debout, tenir un support pour l'équilibre si besoin","Lever une jambe sur le côté en gardant le pied fléchi","Aller jusqu'à la hauteur maximale sans incliner le bassin","Redescendre lentement en contrôlant la résistance","Effectuer toutes les reps d'un côté puis de l'autre"],tips:"Cible les abducteurs et le moyen fessier. Garde le corps droit — ne te penche pas de l'autre côté pour compenser. Peut aussi se faire couché sur le côté."},
  "Leg curl debout élastique": {steps:["Élastique fixé bas, attaché à la cheville","Face au point d'attache, tenir un support pour l'équilibre","Fléchir le genou pour ramener le talon vers les fessiers","Garder la cuisse verticale et le genou dans l'axe","Contracter l'ischio-jambier en fin de mouvement","Redescendre lentement","Effectuer toutes les reps d'un côté puis de l'autre"],tips:"Isole les ischio-jambiers. Garde la cuisse fixe — seul le genou fléchit. Peut aussi se faire allongé sur le ventre."},
  "Adduction cuisses élastique": {steps:["Élastique fixé bas, attaché à la cheville de la jambe de travail","Debout de côté par rapport au point d'attache","Partir jambe écartée dans la direction de l'attache","Ramener la jambe devant ou derrière l'autre en traversant la ligne médiane","Contracter l'adducteur","Revenir lentement en résistant"],tips:"Cible les adducteurs internes des cuisses. Garde le torse droit et l'appui stable sur la jambe de support."},
  "Rotation externe épaule élastique": {steps:["Élastique fixé à hauteur de coude","Coude fléchi à 90° contre le flanc","Saisir l'élastique, paumes vers l'intérieur","Faire pivoter l'avant-bras vers l'extérieur en gardant le coude collé au corps","Aller jusqu'à ce que l'avant-bras soit perpendiculaire au corps","Revenir lentement"],tips:"Renforce les rotateurs externes de l'épaule (infra-épineux, petit rond). Essentiel pour prévenir les blessures d'épaule. Charge très légère, mouvement précis."},
  "Rotation interne épaule élastique": {steps:["Élastique fixé à hauteur de coude, de l'autre côté","Coude fléchi à 90° contre le flanc","Saisir l'élastique, avant-bras écarté vers l'extérieur","Faire pivoter l'avant-bras vers l'intérieur en gardant le coude collé","Aller jusqu'à ce que l'avant-bras touche le ventre","Revenir lentement"],tips:"Renforce les rotateurs internes (sous-scapulaire). Toujours travailler les rotateurs internes ET externes pour équilibrer la coiffe des rotateurs."},
  "Pull apart élastique": {steps:["Tenir l'élastique à deux mains bras tendus devant soi, à hauteur des épaules","Écarter les bras horizontalement en tirant les extrémités","Aller jusqu'à ce que l'élastique touche la poitrine","Contracter les rhomboïdes et deltoïdes postérieurs","Revenir lentement en résistant"],tips:"Excellent exercice correctif pour les postures en avant. À faire quotidiennement pour contre-balancer le travail de bureau. Garde les bras tendus ou légèrement fléchis."},
  "Bicep curl 21s élastique": {steps:["Élastique sous les pieds, tenir les extrémités","7 premières reps : ne monter que jusqu'à mi-chemin (demi-bas)","7 reps suivantes : partir de mi-chemin et monter jusqu'en haut (demi-haut)","7 dernières reps : amplitude complète de bas en haut","Pas de repos entre les 3 séries de 7"],tips:"Technique d'intensification maximale pour les biceps. Les 21 répétitions en continu créent une brûlure intense. Charge légère obligatoire."},
  "Chest press debout élastique": {steps:["Élastique passé dans le dos à hauteur des épaules, tenir les extrémités","Mains à hauteur des épaules, coudes fléchis","Pousser les deux mains en avant jusqu'à l'extension","Contracter les pectoraux en fin de mouvement","Revenir lentement en contrôlant la tension"],tips:"Mouvement de poussée horizontal debout. Peut être fait un bras à la fois pour plus d'intensité. Garde les épaules basses et en arrière."},
  "Squat to press élastique": {steps:["Élastique sous les pieds, tenir les extrémités à hauteur d'épaules","Descendre en squat","En remontant, pousser simultanément les mains au-dessus de la tête","La montée du squat génère de l'élan pour le press","Redescendre les mains en revenant en squat"],tips:"Exercice combiné full body très efficace. Le transfert de force du bas vers le haut fait travailler l'ensemble du corps. Idéal pour le cardio-musculation."},
  "Deadlift élastique": {steps:["Élastique sous les deux pieds, tenir les extrémités dans les mains","Position pieds à largeur d'épaules, dos plat, hanches en arrière","Pousser le sol pour se redresser en gardant l'élastique proche du corps","Extension complète des hanches et des genoux en haut","Redescendre en poussant les hanches en arrière","Garder le dos neutre tout au long"],tips:"Simule le soulevé de terre. La résistance de l'élastique est plus forte en haut du mouvement, ce qui change légèrement le profil de force par rapport à la barre."},
  "Hip abduction couchée élastique": {steps:["Allongé sur le côté, élastique autour des genoux ou chevilles","Corps en ligne droite","Lever la jambe supérieure vers le plafond en gardant le pied fléchi","Aller jusqu'à la hauteur maximale sans faire pivoter le bassin","Redescendre lentement en contrôlant la résistance"],tips:"Cible le moyen fessier et les abducteurs. La position couchée stabilise le bassin et permet un travail d'isolation plus efficace."},
  "Clamshell élastique": {steps:["Allongé sur le côté, hanches et genoux fléchis à 45°, élastique autour des genoux","Pieds superposés, garder les talons joints","Ouvrir le genou supérieur comme une palourde qui s'ouvre","Aller jusqu'à la hauteur maximale sans basculer le bassin","Redescendre lentement"],tips:"Excellent exercice d'activation du moyen fessier avant une séance de jambes ou pour la rééducation du genou. Maintiens les pieds joints tout au long."},
  "Banded walk latéral": {steps:["Élastique autour des genoux ou des chevilles","Légèrement fléchi en mini-squat","Faire des pas latéraux en maintenant la tension de l'élastique","Les pieds ne se rejoignent jamais complètement","Faire un nombre défini de pas vers la droite puis vers la gauche"],tips:"Activation et renforcement des abducteurs et moyen fessier. Garde la tension constante sur l'élastique — ne laisse jamais les pieds se rejoindre. Combiné avec le monster walk."},


  // ── MACHINES ──────────────────────────────────────────────────────────────
  "Leg press": {steps:["S'asseoir dans la machine, dos plat contre le dossier, pieds à largeur d'épaules sur la plateforme","Déverrouiller les sécurités","Fléchir les genoux jusqu'à environ 90°, cuisses parallèles","Pousser la plateforme avec les deux pieds jusqu'à l'extension — ne pas verrouiller les genoux","Redescendre lentement"],tips:"Exercice très efficace pour surcharger les quadriceps. Les pieds hauts ciblent les ischio/fessiers, pieds bas ciblent les quadriceps. Ne jamais verrouiller les genoux en haut."},
  "Leg extension": {steps:["S'asseoir dans la machine, dos contre le dossier, chevilles derrière le rouleau","Régler la machine pour que le genou soit dans l'axe du pivot","Étendre les jambes jusqu'à l'horizontale en contractant les quadriceps","Maintenir 1 seconde en haut","Redescendre lentement en contrôlant"],tips:"Isolation pure des quadriceps. Évite les charges très lourdes — stress articulaire important sur le genou. Mouvement de finition plutôt que de base."},
  "Leg curl": {steps:["S'allonger face contre la machine ou s'asseoir selon le modèle","Placer les chevilles sous le rouleau","Fléchir les genoux pour amener les talons vers les fessiers","Contracter les ischio-jambiers en fin de mouvement","Redescendre lentement"],tips:"Isolation des ischio-jambiers. L'amplitude complète est essentielle. Peut aussi se faire assis sur certaines machines."},
  "Lat pulldown": {steps:["S'asseoir à la machine, genoux bloqués sous les coussinets","Saisir la barre large en pronation, prise légèrement plus large que les épaules","Tirer la barre vers la poitrine en ramenant les coudes vers le bas et en arrière","Contracter le grand dorsal en bas du mouvement","Relâcher lentement jusqu'à l'extension complète des bras"],tips:"Simule les tractions. La barre peut aller derrière la nuque mais c'est déconseillé pour les cervicales. Garde le buste légèrement incliné en arrière."},
  "Chest supported row": {steps:["S'allonger face contre le banc incliné à environ 45°, poitrine bien appuyée","Saisir les haltères ou la barre, bras tendus","Tirer les coudes vers le haut et en arrière","Serrer les omoplates en fin de mouvement","Redescendre lentement"],tips:"L'appui sur le banc neutralise le buste et isole complètement le dos. Excellent pour ceux qui tendent à compenser avec le bas du dos en rowing debout."},
  "Cable fly": {steps:["Deux câbles réglés en hauteur (basse pour cibler le haut, haute pour le bas des pecs)","Saisir une poignée dans chaque main, bras écartés","Ramener les poignées en arc devant la poitrine","Les bras restent légèrement fléchis tout au long","Contracter les pectoraux au centre","Ouvrir lentement en résistant"],tips:"Permet une résistance constante sur toute l'amplitude contrairement aux haltères. Idéal pour l'isolation et le finissage des pectoraux."},
  "Hack squat": {steps:["Se positionner dans la machine, dos contre le dossier incliné, épaules sous les supports","Pieds à largeur d'épaules ou plus large sur la plateforme","Déverrouiller et descendre en fléchissant les genoux jusqu'à 90° ou plus","Pousser avec les pieds pour remonter sans verrouiller","Garder le dos bien plaqué contre le dossier"],tips:"Plus de sécurité que le squat barre car la machine guide le mouvement. Excellent pour isoler les quadriceps avec de lourdes charges."},
  "Pec deck": {steps:["S'asseoir à la machine, dos plat, avant-bras contre les coussinets","Ramener les bras en arc devant la poitrine comme pour une embrassade","Contracter les pectoraux en fin de mouvement","Ouvrir lentement en résistant"],tips:"Isolation totale des pectoraux avec le buste stabilisé. Souvent utilisé en finition ou en pré-fatigue. Amplitude complète = meilleure hypertrophie."},
  "Cable curl": {steps:["Debout face à la poulie basse, poignée en main","Coude contre le corps, avant-bras perpendiculaire au sol","Fléchir l'avant-bras vers l'épaule en maintenant le coude fixe","Contracter le biceps en haut","Redescendre lentement en résistant à la tension du câble"],tips:"La résistance du câble est constante tout au long de l'amplitude, contrairement aux haltères. Peut se faire uni ou bilatéral."},
  "Triceps pushdown câble": {steps:["Debout face à la poulie haute, poignée corde ou barre en main","Coudes fléchis à hauteur du buste, collés aux flancs","Pousser les poignées vers le bas jusqu'à l'extension complète","Contracter les triceps en bas du mouvement","Remonter lentement jusqu'à 90° — ne pas laisser les coudes monter"],tips:"Exercice d'isolation très efficace pour les triceps. Garde les coudes fixes et proches du corps. La corde permet d'écarter les mains en bas pour un pic de contraction."},
};

// ─── CATÉGORIES EXERCICES ─────────────────────────────────────────────────────
const EXERCISE_CATEGORIES = [
  {id:"pectoraux",  label:"Pectoraux",   keywords:["développé couché","développé incliné","développé décliné","développé prise","écarté","pec deck","pompe","dip","pull-over","poitrine élastique"]},
  {id:"dos",        label:"Dos",         keywords:["traction","rowing","tirage","soulevé de terre","good morning","pull-over poulie","superman","australiennes","inversé"]},
  {id:"epaules",    label:"Épaules",     keywords:["militaire","arnold","élévation","oiseau","face pull","tirage menton","turkish","unilatéral kettlebell","développé épaules"]},
  {id:"biceps",     label:"Biceps",      keywords:["curl"]},
  {id:"triceps",    label:"Triceps",     keywords:["skull","barre au front","extension","kickback","dips","développé couché prise serrée","pushdown"]},
  {id:"jambes",     label:"Jambes",      keywords:["squat","presse","leg","fente","hip thrust","soulevé sumo","soulevé roumain","rdl","nordic","mollet","calf","step","step-up","bulgare"]},
  {id:"fessiers",   label:"Fessiers",    keywords:["hip","fessier","glute","donkey","kickback","abduction","clamshell","pont","monster walk","bridge"]},
  {id:"abdos",      label:"Abdos",       keywords:["crunch","planche","gainage","ab","relevé de jambe","oblique","mountain","russe","wheel","core","hollow","bird","sit-up","chandelle","scissors","ciseaux","touche talon","touché talon","toes to bar","pallof","portefeuille","superman"]},
  {id:"cardio",     label:"Cardio",      keywords:["burpee","jumping","mountain climber","sprint","saut","jump","talons","genoux","corde à sauter","snatch","clean","box step"]},
  {id:"kettlebell", label:"Kettlebell",  keywords:["kettlebell","swing","turkish","snatch kettlebell","clean kettlebell","farmer"]},
  {id:"elastique",  label:"Élastique",   keywords:["élastique","bande","résistance","band"]},
  {id:"trapezes",   label:"Trapèzes",    keywords:["shrug","farmer walk","tirage menton"]},
];
const MUSCLE_TO_CAT = {
  "Épaules":          "epaules",
  "Pectoraux":        "pectoraux",
  "Dos":              "dos",
  "Biceps":           "biceps",
  "Triceps":          "triceps",
  "Quadriceps":       "jambes",
  "Ischio-jambiers":  "jambes",
  "Mollets":          "jambes",
  "Fessiers":         "fessiers",
  "Abdominaux":       "abdos",
  "Trapèzes":         "trapezes",
  "Cardio / Full body": "cardio",
};
function getExCategorie(name) {
  const ex = EXERCISE_DATABASE[name];
  if(ex && ex.muscle && MUSCLE_TO_CAT[ex.muscle]) return MUSCLE_TO_CAT[ex.muscle];
  // Fallback keywords pour les exercices hors EXERCISE_DATABASE
  const lower = name.toLowerCase();
  for(const cat of EXERCISE_CATEGORIES){
    if(cat.keywords.some(k => lower.includes(k))) return cat.id;
  }
  return "autres";
}

export { EXERCISE_DATABASE, EX, EXERCISE_GUIDE, EXERCISE_CATEGORIES, getExCategorie, TABATA_EX_BASE };
